<template>
    <div :class="modalMode ? 'details-in-modal mapping-modal' : 'pt-3 pl-5 pr-5'">
        <div class="mb-2" v-if="!modalMode">
            <breadCrumb :routesArray="routesArray"></breadCrumb>
        </div>
        <div class="flex justify-between items-center h-8">
            <div v-if="!modalMode">
                <h1>{{presentProjectObj?.projectName || 'Projects'}}</h1>
            </div>
            <div v-else></div>
            <!-- btndisabled borderForBtndisabled pointer-events-none -->
            <div class="flex items-center gap-3">
                <!-- <button v-if="selectedTabIndex == 1" @click="customPopupPopup" class="btnprimary">Add</button> -->
                <div ref="menuContainer" class="flex flex-row-reverse">
                    <button @click="toggleMenu" v-if="selectedTabIndex == 1" class="btns flex justify-center items-center"  :class="isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'">Add</button>
                        <ul  v-if="isMenuVisible" class="card shadow-sm z-50 absolute cursor-pointer top-24 w-40">
                        <li class="px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="customPopupPopup">
                            <div class="flex" ><img src="@/assets/newControl.svg" alt="" class="mr-2"/>New Control</div>
                        </li>
                        <li class="px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="customClonePopup">
                            <div class="flex" ><img src="@/assets/controlClone.svg" alt="" class="mr-2"/> Clone Control</div>
                        </li>
                        </ul>
                </div>
                <button v-if="selectedTabIndex==1 || selectedTabIndex== 3"
                    :class="activeControlsListDisplay.length>0 ? 'filterButton':'btndisabled borderForBtndisabled pointer-events-none'"
                    @click="filtersOpen()"
                >
                <!-- <img  v-if="sortedDataActiveControls.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/> -->
                    <img :src="activeControlsListDisplay.length>0 ? require('@/assets/filter.svg') : require('@/assets/filterIcon_Disabled.svg')"/>
                    Filters
                </button>
                <button v-if="selectedTabIndex == 2"
                    :class="allControlsListDisplay.length>0 ? 'filterButton':'btndisabled borderForBtndisabled pointer-events-none'"
                    @click="filtersOpen()"
                >
                <!-- <img  v-if="sortedDataAllControls.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/> -->
                    <img :src="allControlsListDisplay.length>0 ? require('@/assets/filter.svg') : require('@/assets/filterIcon_Disabled.svg')"/>
                    Filters
                    
                </button>
            </div>
        </div>

        <div class="mt-3 text-xs">
				{{ presentProjectObj.description}}
		</div>


        <div class="mt-5 bg-white border border-lightgrey relative rounded mapping-tabs-shell">
            <div class="pb-5 px-5 pt-5 w-full h-full flex flex-col min-h-0">
                <Tabs v-model:value="selectedTabIndex" scrollable>
                    <TabList>
                        <Tab v-for="(tab,index) in visibleTabs" :key="index" :value="index" @click="toggleTabs(tab)">
                            {{ tab.displayName }}
                        </Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel v-for="(tab,index) in visibleTabs" :key="index" :value="index">
                            <div v-if="dataLoading">
                                <div class="flex items-center justify-center w-full h-16 skeleton">
                                    <dots-loader/>
                                </div>
                            </div>
                            <div v-else class="w-full">
                                <div v-if="selectedTabIndex == 0" class="noScrollbar tabControlMapping overflow-y-auto">
                                    <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
                                        <dots-loader />
                                    </div>
                                    <div v-else>
                                       <div>
                                            <div class="statuscontainer mt-4">
                                                <div class="formcontainer flex flex-col">
                                                    <div class="row flex flex-row w-full">
                                                        <div class="row flex flex-row w-full ">
                                                            <div class="w-6/12">
                                                                <label class="text-xs font-extrabold">Name</label>
                                                                <div class="mb-3 mt-2 text-sm">{{ presentProjectObj?.projectName || 'N/A'}}</div>
                                                            </div>
                                                            <div class="w-6/12 leftspacing">
                                                                <label class="text-xs font-extrabold">Type</label>
                                                                <div class="mb-3 mt-2 text-sm">{{getProjectType(presentProjectObj.projectType)}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row flex flex-row w-full">
                                                        <div class="w-6/12">
                                                            <label class="text-xs font-extrabold">Customer</label>
                                                            <div class="mb-3 mt-2 text-sm" v-if="presentProjectObj.projectType==10703">{{ presentProjectObj.customerName || 'N/A' }}</div>	
                                                            <div class="mb-3 mt-2 text-sm" v-else>N/A</div>	
                                                        </div>
                                                         <div class="w-6/12 leftspacing">
                                                            <label class="text-xs font-extrabold">Owner</label>
                                                            <div class="mb-3 mt-2 text-sm">{{ getProjectOwner(presentProjectObj.owner)}}</div>
                                                        </div>
                                                    </div>
                                                    <!-- criticality -->
                                                    <div class="row flex flex-row w-full">
                                                        <div class="w-3/6">
                                                            <label class="text-xs font-extrabold">Location</label>
                                                            <div class="mb-3 mt-2 text-sm">{{ getProjectLocation(presentProjectObj.entity) || 'N/A' }}</div>
                                                        </div>
                                                        <div class="w-3/6 leftspacing">
                                                            <label class="text-xs font-extrabold">Time Period</label>
                                                            <!-- <div class="mb-3 mt-2 text-sm">{{ activityObj?.criticality || 'N/A' }}</div> -->
                                                        <div class="mb-3 mt-2 text-sm">{{` ${presentProjectObj.startDate} to ${ presentProjectObj.endDate}` }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="row flex flex-row w-full">
                                                        <div class="w-6/12">
                                                            <label class="text-xs font-extrabold">Severity</label>
                                                             <!-- <div v-if="presentProjectObj.severity"> -->
                                                                    <div class="relative flex items-center regular mt-2">
                                                                        <div class="flex items-center justify-center rounded-full w-5 h-5" :class="colorPropBg('border', presentProjectObj.severity)">
                                                                            <div class="severityCircle rounded-full" :class="colorPropBg('circle', presentProjectObj.severity)"></div>
                                                                        </div>
                                                                    <!-- </div> -->
                                                            </div>
                                                        </div>
                                                        <div class="w-6/12 leftspacing">
                                                            <label class="font-extrabold text-xs">Status</label>
                                                            <div v-if="presentProjectObj.isActive && presentProjectObj.isActive==true"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorStatusBg(1)">
                                                                <div class="text-xs" :class="colorStatusText(1)">
                                                                    {{ getStatusLabel(1) }}
                                                                </div>
                                                            </div>
                                                            <div v-else-if="(presentProjectObj.isActive!=undefined && presentProjectObj.isActive==false)|| !presentProjectObj.isActive"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorStatusBg(2)">
                                                                <div class="text-xs" :class="colorStatusText(2)">
                                                                {{ getStatusLabel(2) }}
                                                                </div>
                                                            </div>
                                                            <div v-else class="text-sm mt-2">N/A</div>
                                                        </div>
                                                    </div>
                                                    <div class="row flex flex-row w-full">
                                                        <div class="">
                                                            <label class="text-xs font-extrabold">Description</label>
                                                            <div class="mb-3 mt-2 text-sm">{{ presentProjectObj?.description || 'N/A' }}</div>		
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div v-if="toolTipActive">
                                        <tool-tip :tipText="toolTipText"></tool-tip>
                                    </div>
                                </div>
                                <div v-if="selectedTabIndex == 1" class="noScrollbar tabControlMapping mapping-tab-pane">
                                    <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
                                        <dots-loader />
                                    </div>
                                    <div v-else class="tableCornerRadius mapping-inline-table">
                                        <div class="table-container table-container-fit">
                                            <div class="table-header-wrap">
                                            <table class="table-fit-card table-header-table" :style="tableResizeStyle">
                                                <thead>
                                                    <tr class="table-header-row">
                                                    <th scope="col" v-for="column in filteredHeaders" @click="onHeaderClick(column)" :class="getHeaderProperties0('width',column)" :key="column" class="bg-white capitalize resizable-th" :style="columnStyle(column)">
                                                        <div class="flex items-center" :class="getHeaderProperties0('widthInner',column)">
                                                            <div class="pl-5 cursor-pointer" v-if="column == 'controlPriority'">
                                                                {{ 'Priority' }}
                                                            </div>
                                                            <!-- <div v-else-if=" name == 'actionButtonAtCompliance' || name == 'actionButtonAtObjective' || name == 'actionButtonForKPIs' || name == 'compliancePeriod' || name == 'TotalNumberofControls' || name == 'No. of Controls' || name == 'no.of controls' || name == 'weightage (%)' || name == 'frameWorks'|| name == 'no.of Kpis' || name == 'Weightage (%)' || name == 'Date of Target' || name == 'startDate' || name == 'createdAt' ||  name=='endDate' || name=='Date of Target' || name=='KPIs' || name == 'No. of Controls' || name == 'kpiDelete' || name == 'deleteIcon'"></div> -->
                                                            <div v-else class="cursor-pointer">{{ getHeaderProperties0('name',column) }}</div>
                                                            <div class="sort cursor-pointer" :class="className == column? classSort : 'opacity-50'" v-if="column!='actionButtonForControls'"></div>
                                                        </div>
                                                    <span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, column)"></span></th>
                                                    </tr>
                                                    <tr v-if="showFilters" class="table-filter-row">
                                                        <!-- <td></td> -->
                                                        <td v-for="(name, index) in activeControlHeaders" class="bg-white" :key="index" :style="columnStyle(name)">
                                                            <!-- {{name}} -->
                                                            <select v-if="name == 'classificationType'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in controlTypeValues" :key="pair" :value="pair.id">{{ pair.value }}</option>
                                                            </select>
                                                            <select v-else-if="name == 'controlPriority'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in dbPriority" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                                            </select>
                                                            <select v-else-if="name == 'controlFrequency'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in dbFrequency" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                                            </select>
                                                            <div v-else-if="name == 'actionButtonForControls'"></div>
                                                            <input v-else type="text" class="searchForInputBoxStyling filter-font-size" placeholder="Search" v-model="allFilters[name]" />
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>
                                            </div>
                                            <div class="table-body-scroll">
                                            <table class="table-fit-card" :style="tableResizeStyle">
                                                <tbody v-if="dataLoading == true">
                                                    <tr class="cursor-pointer rowHeight">
                                                        <td class="relative h-10" :colspan="activeControlHeaders.length+1">
                                                            <div class="flex items-center justify-center w-full h-16 skeleton">
                                                                <dots-loader/>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else-if="sortedDataActiveControls.length == 0">
                                                    <tr class="cursor-pointer rowHeight">
                                                        <td class="relative h-10" :colspan="activeControlHeaders.length">
                                                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody class="nonEmptyTable" v-else>
                                                    <tr v-for="(controlObject,index) in sortedDataActiveControls" :key="index" class="cursor-pointer rowHeight hoverEffectForCompleteRow">
                                                        <!-- <td> -->
                                                            <!-- <input class="checkbox" type="checkbox" v-model="checkedActiveControls" @change="changedActiveControlInput()" :value="controlObject._id" /> -->
                                                        <!-- </td> -->
                                                        
                                                        <td scope="col" v-for="column in filteredHeaders" @click="showControlDetailsPopup(controlObject)" @mouseout="doFalse()" :key="column" :class="selectedTabIndex === 3 ? getHeaderProperties2('width',column) : getHeaderProperties0('width',column)" :style="columnStyle(column)">
                                                            <div v-if="column == 'classificationType'">
                                                                <div>{{ getControlTypeValue( controlObject['classificationType']) }}</div>
                                                            </div>
                                                            <div v-else-if="column == 'controlFrequency'">
                                                                <div>{{ getFrequencyValue( controlObject['controlFrequency'] ) }}</div>
                                                            </div>
                                                            <div v-else-if="column == 'controlPriority'"> 
                                                                <div
                                                                    class="flex items-center justify-center rounded h-5 w-24 lablePadding"
                                                                    :class="colorLabelBg(controlObject[column])"
                                                                >
                                                                    <div :class="colorLabelText(controlObject[column])">
                                                                        {{ getProirityLabel(controlObject[column]) }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <div v-else-if="column == 'actionButtonForControls'">
                                                                        <div 
                                                                            class="action-button-container relative"
                                                                            @click.stop="calculateDropdownPosition(controlObject, index, column)"
                                                                            :data-row-index="index"
                                                                        >
                                                                            <div class="flex justify-end items-center w-5 h-5">
                                                                            <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                                                            </div>
                                                                            
                                                                            <ul
                                                                            v-if="showBlock && showBlockindex === index"
                                                                            class="card shadow-sm absolute cursor-pointer z-50 actionButtonStyling"
                                                                            :class="[
                                                                                dropdownDirection[index] === 'up' ? 'dropdown-up' : 'dropdown-down',
                                                                                'min-w-[150px]'
                                                                            ]"
                                                                            >
                                                                            <li class="cursor-pointer lastChild border-lightgrey hover:bg-lightgrey h-7 flex items-center" :class="option.value == 'Reports' ? '' : 'border-b'" v-for="(option, index) in controlDeactiveOptions" @click="optionClickedOnAction(option.value,controlObject)" :key="index" v-if="selectedTabIndex==0">
                                                                                
                                                                                <div class="flex items-center" v-if="option.value == 'Edit'">
                                                                                    <img src="@/assets/editIcon.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                                <div class="flex items-center" v-if="option.value == 'Deactivate'">
                                                                                    <img src="@/assets/activationButton.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                            </li>
                                                                            <li class="cursor-pointer lastChild border-lightgrey hover:bg-lightgrey h-7 flex items-center" :class="option.value == 'Reports' ? '' : 'border-b'" v-for="(option, index) in controlActiveOptions" @click="optionClickedOnAction(option.value,controlObject)" :key="index" v-if="selectedTabIndex==2">
                                                                                
                                                                                <div class="flex items-center" v-if="option.value == 'Edit'">
                                                                                    <img src="@/assets/editIcon.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                                <div class="flex items-center" v-if="option.value == 'Activate'">
                                                                                    <img src="@/assets/activationButton.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                            </li>
                                                                            </ul>
                                                                        </div>
                                                                    </fieldset>
                                                                </div> -->
                                                                <div v-else-if="column === 'actionButtonForControls' && selectedTabIndex==1" class="relative menuWidth"  style="display: flex;align-items: center;justify-content: center;">
                                                                    <Button
                                                                        class="action-button"
                                                                        type="button"
                                                                        icon="pi pi-ellipsis-v"
                                                                        @click.stop="actionButtonToggle($event, index)"
                                                                    />
                                                                    <Menu
                                                                        :ref="'menu' + index"
                                                                        :model="actionButtonAtControl(controlObject)"
                                                                        :popup="true"
                                                                        appendTo="body"
                                                                        class="menuWidth"
                                                                    />
                                                                </div>

                                                            <div v-else>
                                                                <div class="table-ellipsis">
                                                                    <p class="fullText" @mousemove="toolTip(column, $event, index, controlObject, 'text')">
                                                                        {{ controlObject[column] }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        <div v-if="sortedDataActiveControls.length > 0">
                                            <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedDataActiveControls"></pagination>
                                        </div>
                                    </div>
                                    <div v-if="toolTipActive">
                                        <tool-tip :tipText="toolTipText"></tool-tip>
                                    </div>
                                </div>

                                <div v-else-if="selectedTabIndex == 2" class=" noScrollbar tabControlMapping mapping-tab-pane">
                                    <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
                                        <dots-loader />
                                    </div>
                                    <div v-else class="tableCornerRadius mapping-inline-table">
                                        <div class="table-container table-container-fit">
                                            <div class="table-header-wrap">
                                            <table class="table-fit-card table-header-table" :style="tableResizeStyle">
                                                <thead>
                                                    <tr class="buttomStyle table-header-row">
                                                        <!-- <th class="header cursor-pointer" > -->
                                                            <!-- <div class="flex items-center">
                                                                <input type="checkbox" v-model="selectAllOptionAllControls" class="checkbox cursor-pointer" :disabled="allControlsList.length == 0" @change="selectAllAllControls($event)" />
                                                            </div> -->
                                                        <!-- </th> -->
                                                        <th scope="col" v-for="column in allControlHeaders" @click="onHeaderClick(column)" :class="getHeaderProperties1('width',column)" :key="column" class="bg-white capitalize resizable-th" :style="columnStyle(column)">
                                                            <div class="flex items-center"  :class="getHeaderProperties1('widthInner',column)">
                                                                <div class="pl-5 cursor-pointer" v-if="column == 'controlPriority'">
                                                                    {{ 'Priority' }}
                                                                </div>
                                                                <div v-else class="cursor-pointer">{{ getHeaderProperties1('name',column) }}</div>
                                                                <div class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>
                                                            </div>
                                                        <span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, column)"></span></th>
                                                    </tr>
                                                    <tr v-if="showFilters" class="table-filter-row">
                                                        <td v-for="(name, index) in allControlHeaders" class="bg-white" :key="index" :style="columnStyle(name)">
                                                            <select v-if="name == 'classificationType'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in controlTypeValues" :key="pair" :value="pair.id">{{ pair.value }}</option>
                                                            </select>
                                                            <select v-else-if="name == 'controlPriority'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in dbPriority" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                                            </select>
                                                            <input v-else type="text" class="searchForInputBoxStyling filter-font-size" placeholder="Search" v-model="allFilters[name]" />
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>
                                            </div>
                                            <div class="table-body-scroll">
                                            <table class="table-fit-card" :style="tableResizeStyle">
                                                <tbody v-if="dataLoading == true">
                                                    <tr class="cursor-pointer rowHeight">
                                                        <td class="relative h-10" :colspan="allControlHeaders.length+1">
                                                            <div class="flex items-center justify-center w-full h-16 skeleton">
                                                                <dots-loader/>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else-if="sortedDataAllControls.length == 0">
                                                    <tr class="cursor-pointer rowHeight">
                                                        <td class="relative h-10" :colspan="allControlHeaders.length">
                                                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody class="nonEmptyTable" v-else>
                                                    <tr v-for="(controlObject,index) in sortedDataAllControls" :key="index" class="cursor-pointer rowHeight hoverEffectForCompleteRow">
                                                        <!-- <td>
                                                            <input class="checkbox" type="checkbox" v-model="checkedAllControls" @change="changedAllControlInput()" :value="controlObject._id" />
                                                        </td> -->
                                                        
                                                        <td scope="col" v-for="column in allControlHeaders" @mouseout="doFalse()" @click="showControlDetailsPopup(controlObject)" :key="column" :style="columnStyle(column)">
                                                            <div v-if="column == 'classificationType'">
                                                                <div>{{ getControlTypeValue( controlObject['classificationType'] ) }}</div>
                                                            </div>

                                                            <div v-else-if="column == 'controlPriority'">
                                                                <div
                                                                    class="flex items-center justify-center rounded h-5 w-24 lablePadding"
                                                                    :class="colorLabelBg(controlObject[column])"
                                                                >
                                                                    <div :class="colorLabelText(controlObject[column])">
                                                                        {{ getProirityLabel(controlObject[column]) }}
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>

                                                            <div v-else>
                                                                <div class="table-ellipsis">
                                                                    <p class="fullText" @mousemove="toolTip(column, $event, index, controlObject, 'text')">
                                                                        {{ controlObject[column] }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        <div v-if="sortedDataAllControls.length > 0">
                                            <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedDataAllControls"></pagination>
                                        </div>
                                    </div>
                                    <div v-if="toolTipActive">
                                        <tool-tip :tipText="toolTipText"></tool-tip>
                                    </div>
                                </div>
                                <div v-if="selectedTabIndex == 3" class="noScrollbar tabControlMapping mapping-tab-pane">
                                    <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
                                        <dots-loader />
                                    </div>
                                    <div v-else class="tableCornerRadius mapping-inline-table">
                                        <div class="table-container table-container-fit">
                                            <div class="table-header-wrap">
                                            <table class="table-fit-card table-header-table" :style="tableResizeStyle">
                                                <thead>
                                                    <tr class="table-header-row">
                                                    <th scope="col" v-for="column in filteredHeaders" @click="onHeaderClick(column)" :class="getHeaderProperties2('width',column)" :key="column" class="bg-white capitalize resizable-th" :style="columnStyle(column)">
                                                        <div class="flex items-center" :class="getHeaderProperties2('widthInner',column)">
                                                            <div class="pl-5 cursor-pointer" v-if="column == 'controlPriority'">
                                                                {{ 'Priority' }}
                                                            </div>
                                                            <!-- <div v-else-if=" name == 'actionButtonAtCompliance' || name == 'actionButtonAtObjective' || name == 'actionButtonForKPIs' || name == 'compliancePeriod' || name == 'TotalNumberofControls' || name == 'No. of Controls' || name == 'no.of controls' || name == 'weightage (%)' || name == 'frameWorks'|| name == 'no.of Kpis' || name == 'Weightage (%)' || name == 'Date of Target' || name == 'startDate' || name == 'createdAt' ||  name=='endDate' || name=='Date of Target' || name=='KPIs' || name == 'No. of Controls' || name == 'kpiDelete' || name == 'deleteIcon'"></div> -->
                                                            <div v-else class="cursor-pointer">{{ getHeaderProperties2('name',column) }}</div>
                                                            <div class="sort cursor-pointer" :class="className == column? classSort : 'opacity-50'" v-if="column!='actionButtonForControls'"></div>
                                                        </div>
                                                    <span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, column)"></span></th>
                                                    </tr>
                                                    <tr v-if="showFilters" class="table-filter-row">
                                                        <!-- <td></td> -->
                                                        <td v-for="(name, index) in InactiveControlHeaders" class="bg-white" :key="index" :style="columnStyle(name)">
                                                            <!-- {{name}} -->
                                                            <select v-if="name == 'classificationType'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in controlTypeValues" :key="pair" :value="pair.id">{{ pair.value }}</option>
                                                            </select>
                                                            <select v-else-if="name == 'controlPriority'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in dbPriority" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                                            </select>
                                                            <select v-else-if="name == 'controlFrequency'"  class="widthForSelect" :class="allFilters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="allFilters[name]">
                                                                <option :value="allFilters.name" selected disabled hidden>Select</option>
                                                                <option class="optionColors" v-for="pair in dbFrequency" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                                            </select>
                                                            <div v-else-if="name == 'actionButtonForControls'"></div>
                                                            <input v-else type="text" class="searchForInputBoxStyling filter-font-size" placeholder="Search" v-model="allFilters[name]" />
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>
                                            </div>
                                            <div class="table-body-scroll">
                                            <table class="table-fit-card" :style="tableResizeStyle">
                                                <tbody v-if="dataLoading == true">
                                                    <tr class="cursor-pointer rowHeight">
                                                        <td class="relative h-10" :colspan="InactiveControlHeaders.length+1">
                                                            <div class="flex items-center justify-center w-full h-16 skeleton">
                                                                <dots-loader/>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-else-if="sortedDataActiveControls.length == 0">
                                                    <tr class="cursor-pointer rowHeight">
                                                        <td class="relative h-10" :colspan="InactiveControlHeaders.length">
                                                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody class="nonEmptyTable" v-else>
                                                    <tr v-for="(controlObject,index) in sortedDataActiveControls" :key="index" class="cursor-pointer rowHeight hoverEffectForCompleteRow">
                                                        <!-- <td> -->
                                                            <!-- <input class="checkbox" type="checkbox" v-model="checkedActiveControls" @change="changedActiveControlInput()" :value="controlObject._id" /> -->
                                                        <!-- </td> -->
                                                        
                                                        <td scope="col" v-for="column in filteredHeaders" @click="showControlDetailsPopup(controlObject)" @mouseout="doFalse()" :key="column" :class="selectedTabIndex === 3 ? getHeaderProperties2('width',column) : getHeaderProperties0('width',column)" :style="columnStyle(column)">
                                                            <div v-if="column == 'classificationType'">
                                                                <div>{{ getControlTypeValue( controlObject['classificationType']) }}</div>
                                                            </div>
                                                            <div v-else-if="column == 'controlFrequency'">
                                                                <div>{{ getFrequencyValue( controlObject['controlFrequency'] ) }}</div>
                                                            </div>
                                                            <div v-else-if="column == 'controlPriority'"> 
                                                                <div
                                                                    class="flex items-center justify-center rounded h-5 w-24 lablePadding"
                                                                    :class="colorLabelBg(controlObject[column])"
                                                                >
                                                                    <div :class="colorLabelText(controlObject[column])">
                                                                        {{ getProirityLabel(controlObject[column]) }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <div v-else-if="column == 'actionButtonForControls'">
                                                                        <div 
                                                                            class="action-button-container relative"
                                                                            @click.stop="calculateDropdownPosition(controlObject, index, column)"
                                                                            :data-row-index="index"
                                                                        >
                                                                            <div class="flex justify-end items-center w-5 h-5">
                                                                            <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                                                            </div>
                                                                            
                                                                            <ul
                                                                            v-if="showBlock && showBlockindex === index"
                                                                            class="card shadow-sm absolute cursor-pointer z-50 actionButtonStyling"
                                                                            :class="[
                                                                                dropdownDirection[index] === 'up' ? 'dropdown-up' : 'dropdown-down',
                                                                                'min-w-[150px]'
                                                                            ]"
                                                                            >
                                                                            <li class="cursor-pointer lastChild border-lightgrey hover:bg-lightgrey h-7 flex items-center" :class="option.value == 'Reports' ? '' : 'border-b'" v-for="(option, index) in controlDeactiveOptions" @click="optionClickedOnAction(option.value,controlObject)" :key="index" v-if="selectedTabIndex==0">
                                                                                
                                                                                <div class="flex items-center" v-if="option.value == 'Edit'">
                                                                                    <img src="@/assets/editIcon.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                                <div class="flex items-center" v-if="option.value == 'Deactivate'">
                                                                                    <img src="@/assets/activationButton.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                            </li>
                                                                            <li class="cursor-pointer lastChild border-lightgrey hover:bg-lightgrey h-7 flex items-center" :class="option.value == 'Reports' ? '' : 'border-b'" v-for="(option, index) in controlActiveOptions" @click="optionClickedOnAction(option.value,controlObject)" :key="index" v-if="selectedTabIndex==2">
                                                                                
                                                                                <div class="flex items-center" v-if="option.value == 'Edit'">
                                                                                    <img src="@/assets/editIcon.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                                <div class="flex items-center" v-if="option.value == 'Activate'">
                                                                                    <img src="@/assets/activationButton.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                                                                    {{ option.value }}
                                                                                </div>
                                                                            </li>
                                                                            </ul>
                                                                        </div>
                                                                    </fieldset>
                                                                </div> -->
                                                                <div v-else-if="column === 'actionButtonForControls' && selectedTabIndex==1" class="relative menuWidth"  style="display: flex;align-items: center;justify-content: center;">
                                                                    <Button
                                                                        class="action-button"
                                                                        type="button"
                                                                        icon="pi pi-ellipsis-v"
                                                                        @click.stop="actionButtonToggle($event, index)"
                                                                    />
                                                                    <Menu
                                                                        :ref="'menu' + index"
                                                                        :model="actionButtonAtControl(controlObject)"
                                                                        :popup="true"
                                                                        appendTo="body"
                                                                        class="menuWidth"
                                                                    />
                                                                </div>

                                                            <div v-else>
                                                                <div class="table-ellipsis">
                                                                    <p class="fullText" @mousemove="toolTip(column, $event, index, controlObject, 'text')">
                                                                        {{ controlObject[column] }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        <div v-if="sortedDataActiveControls.length > 0">
                                            <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedDataActiveControls"></pagination>
                                        </div>
                                    </div>
                                    <div v-if="toolTipActive">
                                        <tool-tip :tipText="toolTipText"></tool-tip>
                                    </div>
                                </div>
                                <div v-else-if="selectedTabIndex == 4" class="noScrollbar tabControlMapping history-tab-pane mapping-tab-pane">
                                <div v-if="tabDataLoading" class="flex items-center justify-center w-full h-64">
                                    <dots-loader />
                                </div>
                                <div v-else class="history-tab-inner flex flex-col flex-1 min-h-0 overflow-hidden pt-2">
                                        <div class="border-b border-lightgrey flex justify-between pb-2 flex-shrink-0">
                                            <div class="flex items-center justify-center">
                                                <div>
                                                <p class="header">History</p>
                                                </div>
                                            </div>
                                            <div class="buttonposition flex justify-end items-center">
                                                <button class="filterButton w-24 flex taskEditButtons" v-if="newHistory" @click="sortWorkLog()" :class="workLogObject?.[0] && Object.keys(workLogObject[0]).includes('history') && workLogObject[0].history?.length !== 0 ? 'btnprimary' : 'pointer-events-none'">
                                                        <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                                        Oldest
                                                </button>
                                                <button class="filterButton w-24 flex taskEditButtons" v-if="!newHistory" @click="sortWorkLog()">
                                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                                    Newest
                                                </button>
                                            </div>
                                        </div>
                                        <div class="history-entries-scroll flex-1 min-h-0 overflow-y-auto pr-2 scrollBarColour">
                                        <div v-for="work in workLogObject[0]?.history" :key="work" class="bg-white py-4 mb-0.5 border-lightgrey border-b">
                                            <div class="flex">
                                                <!-- {{ work }} -->
                                                <div v-if="Object.keys(work).includes('activatedBy')" class="initials">
                                                    {{ extractInitials(work.name) }}
                                                </div>
                                                <div v-else-if="Object.keys(work).includes('createdBy')" class="initials">
                                                    {{ extractInitials(work.name) }}
                                                </div>
                                                <div class="logContainer w-93">
                                                    <div class="flex">
                                                        <!-- {{ work }} -->
                                                        <p v-if="Object.keys(work).includes('activatedBy')" class="font-semibold mt-1.5 text-xs">
                                                            {{ work.name }}
                                                        </p>
                                                        <p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold mt-1.5 text-xs">
                                                            {{ work.name }}
                                                        </p>
                                                        <div v-if="work.hasOwnProperty('currentControlOwner')" class="mx-2 mt-1.5 text-xs">
                                                        <p>
                                                        {{ 'Updated the ' }}
                                                        <b>{{ work.clientUniqueId }}</b>
                                                        <span class="ml-2">{{ 'on' }}</span>
                                                        <span class="pl-2"><b>{{ formatTime(work.activatedAt) }}</b></span>
                                                        </p>
                                                        <div class="mt-3">
                                                        {{ 'Control Owner from ' }}
                                                        <b>{{ getControlOwnerName(work.previousControlOwner) }}</b>
                                                        {{ ' to ' }}
                                                        <b>{{ getControlOwnerName(work.currentControlOwner) }}</b>
                                                        </div>
                                                        </div>
                                                        <div  v-else-if="Object.keys(work).includes('activatedBy') && work.controlStatus==true && (Object.keys(work).includes('currentPriority') || Object.keys(work).includes('currentFrequency')) && Object.keys(work).includes('actionType') && work.actionType==10301" class="mx-2 mt-1.5 text-xs">
                                                        <p>{{ 'Activated the ' }}<b>{{`${work.clientUniqueId}`}} </b> {{ 'on' }}<span class="pl-2"><b>{{formatTime(work.activatedAt)}}</b></span></p>
                                                        </div>
                                                        <div  v-else-if="Object.keys(work).includes('activatedBy') && work.controlStatus==true && !Object.keys(work).includes('currentPriority') && !Object.keys(work).includes('currentFrequency') && Object.keys(work).includes('actionType') && work.actionType==10301" class="mx-2 mt-1.5 text-xs">
                                                        <p>{{ 'Created the ' }}<b>{{`${work.clientUniqueId}`}} </b> {{ 'on' }}<span class="pl-2"><b>{{formatTime(work.createdAt)}}</b></span></p>
                                                        </div>
                                                        <div  v-else-if="work.activatedBy && work.previousPriority&&work.controlStatus!==false" class="mx-2 mt-1.5 text-xs">
                                                        <p>
                                                        {{ 'Updated the ' }}
                                                        <b>{{ work.clientUniqueId }}</b>
                                                        <span class="ml-2">{{'on'}}</span>
                                                        <span class="pl-2"><b>{{ formatTime(work.activatedAt) }}</b></span>
                                                        </p>
                                                        <div class="mt-3">
                                                        {{'from'}}
                                                        <span :class="colorLabelBg(work.previousPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding" v-if="work.previousPriority&&typeof work.previousPriority!='string'">
                                                            <span :class="colorLabelText(work.previousPriority)" class="text-xs">
                                                                {{ getProirityLabel(work.previousPriority) }}
                                                            </span>
                                                        </span>
                                                        <span  v-else>
                                                            N/A
                                                        </span>
                                                        {{ ' to ' }}
                                                            <span :class="colorLabelBg(work.currentPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding">
                                                            <span :class="colorLabelText(work.currentPriority)" class="text-xs">
                                                                {{ getProirityLabel(work.currentPriority) }}
                                                            </span>
                                                        </span>
                                                        <b>in ActiveControls</b>
                                                        </div>
                                                        </div>
                                                        <div  v-else-if="work.activatedBy && (work.previousPriority || work.currentPriority)&&work.controlStatus==false" class="mx-2 mt-1.5 text-xs">
                                                        <p>
                                                        {{ 'Updated the ' }}
                                                        <b>{{ work.clientUniqueId }}</b>
                                                        <span class="ml-2">{{'on'}}</span>
                                                        <span class="pl-2"><b>{{ formatTime(work.activatedAt) }}</b></span>
                                                        </p>
                                                        <div class="mt-3">
                                                        {{'from'}}
                                                        <span :class="colorLabelBg(work.previousPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding" v-if="work.previousPriority&&typeof work.previousPriority!='string'">
                                                            <span :class="colorLabelText(work.previousPriority)" class="text-xs">
                                                                {{ getProirityLabel(work.previousPriority) }}
                                                            </span>
                                                        </span>
                                                        <span  v-else>
                                                            N/A
                                                        </span>
                                                        {{ ' to ' }}
                                                            <span :class="colorLabelBg(work.currentPriority)" class="inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding">
                                                            <span :class="colorLabelText(work.currentPriority)" class="text-xs">
                                                                {{ getProirityLabel(work.currentPriority) }}
                                                            </span>
                                                        </span>   
                                                            <b>in InactiveControls</b>
                                                        </div>
                                                        </div>
                                                        <div  v-else-if="work.activatedBy&&(work.previousFrequency || work.currentFrequency)" class="mx-2 mt-1.5 text-xs">
                                                            <p>
                                                                {{ 'Updated the ' }}
                                                                <b>{{ work.clientUniqueId }}</b>
                                                                <span class="ml-2">{{ 'on' }}</span>
                                                                <span class="pl-2"><b>{{ formatTime(work.activatedAt) }}</b></span>
                                                            </p>
                                                            <div class="mt-3">
                                                                {{ 'from' }}
                                                                <span>
                                                                <b>{{ getFrequencyValue(work.previousFrequency)}}</b>
                                                                </span>
                                                                {{ ' to ' }}
                                                                <span>
                                                                <b>{{ getFrequencyValue(work.currentFrequency) }}</b>
                                                                </span>
                                                            </div>
                                                            </div>
                                                        <div  v-else-if="work.activatedBy&&work.actionType==10302&&work.controlStatus==false" class="mx-2 mt-1.5 text-xs">
                                                        <p>{{ 'Activating the ' }}<b>{{`${work.clientUniqueId}`}} </b> {{ 'on' }}<span class="pl-2"><b>{{formatTime(work.updatedAt)}}</b></span></p>
                                                        </div>
                                                         <div  v-else-if="work.activatedBy&&work.actionType==10302&&work.controlStatus==true" class="mx-2 mt-1.5 text-xs">
                                                            <p>{{ 'Activated the ' }}<b>{{`${work.clientUniqueId}`}} </b> {{ 'on' }}<span class="pl-2"><b>{{formatTime(work.updatedAt)}}</b></span></p>
                                                        </div>
                                                        <div  v-else-if="work.activatedBy&&work.actionType==10303 && work.justification!=''" class="mx-2 mt-1.5 text-xs">
                                                        <p>{{ 'Deactivated the ' }}<b>{{`${work.clientUniqueId}`}} </b><span class="ml-2">{{ 'on' }}</span><span class="pl-2"><b>{{formatTime(work.updatedAt)}}</b></span> </p>
                                                        </div>
                                                        <div  v-else-if="work.updatedBy&&work.updatedIn=='DeactivatedControls'&&work.actionType==10302" class="mx-2 mt-1.5 text-xs">
                                                        <p>{{ 'updated the ' }}<b>{{`${work.clientUniqueId}`}} </b>{{ ' in Inactive at' }}<span class="pl-2"><b>{{formatTime(work.updatedAt)}}</b></span></p>
                                                        </div>
                                                        <div  v-else-if="work.updatedBy&&work.updatedIn=='ActivatedControls'&&work.actionType==10303" class="mx-2 mt-1.5 text-xs">
                                                        <p>{{ 'Activated the ' }}<b>{{`${work.clientUniqueId} `}} </b>{{  'on' }}<span class="pl-2"><b>{{formatTime(work.updatedAt)}}</b></span></p>
                                                        </div>
                                                    </div>
                                                    <div v-if="work.activatedBy&&work.actionType==10303 && work.justification!=''" class="mt-1 text-xs">
                                                        <b>Justification:</b><span class="ml-0.5">{{ `${work.justification}` }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                </div>
                                </div>
                            </div>
                        </TabPanel>
                    </TabPanels>

                </Tabs>
                
            </div>        <!-- <div v-if="selectedTabIndex == 0" class="bottom-7 bg-white h-14 flex justify-end items-center w-full  rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
                <div class="buttonposition flex justify-end items-center px-5 mx-5">
                    <button class="btnprimary mr-1.5" @click="cancelActiveControls()" :class="arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary'">Cancel</button>
                    <button class="btnprimary" :disabled="clickOnButton" @click="saveControlsChangeForActivity(10303)" :class="arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary'">Save</button>
                </div>
            </div> -->

            <!-- <div v-if="selectedTabIndex == 2" class="bottom-7 bg-white h-14 flex justify-end items-center w-full  rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
                <div class="buttonposition flex justify-end items-center px-5 mx-5">
                    <button @click="onCancelAllControls()" :class="checkedAllControls.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary mr-1.5" >Cancel</button>
                    <button @click="saveControlsChangeForActivity(10301)" :class="checkedAllControls.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary">Save</button>
                </div>
            </div> -->
        </div>
    </div>

    
    <popup v-if="customPopup" :popUp="customPopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1 v-if="customControlObject != undefined && customControlObject.classificationType == 3 " class="pl-2">{{customControlObject.controlTitle}}</h1>
                <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Control</h1>
                </div>
                <button class="float-right text-3xl" @click="onCancelbtnCustom('close')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
<div class="flex flex-col h-full">
    <div class="flex-1 overflow-auto">
            <fieldset :disabled="customControlObject._id">
            <div>
                <div class="statuscontainer popupbodycontainer">
                    <div class="formcontainer flex flex-col">
                        <div v-if="addpopup==true" class="row flex flex-row w-full">
                            <div class="w-full mt-3">
                                <label class="controllabel">Title</label>
                                <!-- <div class="mb-3 mt-2 text-sm">{{ customControlObject.controlTitle || 'N/A'}}</div> -->
                                <textarea 
                                    type="text-area"
                                    class="inputboxstyling mt-2"
                                    placeholder="Title"
                                    @input="v$.customControlObject.controlTitle.$touch()" 
                                    v-model.trim="customControlObject.controlTitle"
                                    :class="{
                                        'is-invalid': v$.customControlObject.controlTitle.$error
                                    }"
                                ></textarea>
                                <div v-if="v$.customControlObject.controlTitle.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customControlObject.controlTitle.required.$invalid">Required</div>
                                    <div v-else-if="v$.customControlObject.controlTitle && v$.customControlObject.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row w-full"> 
                            <div class="w-6/12 " :class="{'topspace': addpopup}">
                                <label class="controllabel text-xs">Frequency</label>
                                <div class="text-sm mt-2 mb-3" v-if="addpopup==false && (selectedTabIndex!=1|| selectedTabIndex==1)">{{ dbFrequency.find((item:any) => item.value === customControlObject.controlFrequency)?.key ?? 'N/A' }}</div>
                                <!-- <select v-else class="mt-2" :class="{ 'is-invalid': v$.customControlObject.controlFrequency.$error,'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlFrequency !== '' }" v-model="customControlObject.controlFrequency">
                                    <option value="" selected disabled hidden>Select</option>
                                    <option class="optionColors" v-for="(value, index) in controlFrequencyArray" :key="index" :value="value.id">{{ value.label }}</option>
                                </select> -->
                                <Select v-else
                                    v-model="customControlObject.controlFrequency"
                                    :options="dbFrequency"
                                    optionLabel="key"
                                    optionValue="value"
                                    placeholder="Please select one"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                        'is-invalid': v$.customControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '',
                                    }"
                                />
                                <div v-if="v$.customControlObject.controlFrequency.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customControlObject.controlFrequency.required.$invalid">Required</div>
                                </div>
                        
                            </div>
                            <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                <label class="controllabel text-xs">Priority</label>
                                <div class="mb-3 mt-2 text-sm" v-if="addpopup==false && (selectedTabIndex!=1|| selectedTabIndex==1)" >
                                    <div v-if="customControlObject.controlPriority && typeof customControlObject.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(customControlObject.controlPriority)">
                                        <div class="text-xs" :class="colorLabelText(customControlObject.controlPriority)">
                                            {{ getProirityLabel(customControlObject.controlPriority) }}
                                        </div>
                                    </div>
                                <div v-else>N/A</div>
                                <!-- {{ dbPriority.find(item => item.value === customControlObject.controlPriority)?.key || 'N/A' }} -->
                                </div>
                                <!-- <select v-else class="mt-2" v-model="customControlObject.controlPriority" :class="{'inputboxstylingForSelectAtPopup': customControlObject.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': customControlObject.controlPriority !== ''}">
                                    <option value="" selected disabled hidden>Select</option>
                                    <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value.key }}</option>
                                </select> -->
                                    <Select
                                    v-else
                                    v-model="customControlObject.controlPriority"
                                    :options="dbPriority"
                                    optionLabel="key"
                                    optionValue="value"
                                    placeholder="Please select one"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                        'is-invalid': v$.customControlObject.controlPriority.$error,
                                        'inputboxstylingForSelectAtPopup': customControlObject.controlPriority === '',
                                        'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlPriority !== ''
                                    }"
                                />
                                <div v-if="v$.customControlObject.controlPriority.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customControlObject.controlPriority.required.$invalid">Required</div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="flex flex-row w-full">
                        <div class="w-6/12 topspace">
                                <label class="controllabel">Number</label>
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.clientUniqueId ? customControlObject.clientUniqueId : customControlObject.controlNumber || 'N/A'}}</div>
                                <input
                                    v-else
                                    type="text"
                                    class="inputboxstyling mt-2 disiableState"
                                    v-model.trim="customControlObject.controlNumber"
                                    @input="v$.customControlObject.controlNumber.$touch()"
                                    placeholder="Number"
                                    disabled
                                />
                            </div>
                         <div class="w-6/12 leftspacing topspace">
                                    <div>
                                    <label class="controllabel">Category</label>
                                    <div> 
                                        <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlType || 'N/A'}}</div>
                                        <!-- <input
                                            v-else
                                            type="text"
                                            class="inputboxstyling"
                                            @input="v$.customControlObject.controlType.$touch()"
                                            
                                            v-model.trim="customControlObject.controlType"
                                            placeholder="Type"
                                            :class="{
                                                'is-invalid': v$.customControlObject.controlType.$error
                                            }"
                                        /> -->
                                            <div v-else>
                                            <AutoComplete 
                                            v-model="customControlObject.controlType"
                                            :suggestions="filteredControlTypeOptions"
                                            @complete="asyncFindControlType"
                                            field="label"
                                            :forceSelection="true"
                                            placeholder="Category"
                                            class="p-inputtext-sm systemsstyling  mt-2"
                                            />
                                        </div>
                                    <div v-if="v$.customControlObject.controlType.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlType && v$.customControlObject.controlType.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            
                               
                        
                        </div>

                    

                        <div class="formcontainer flex flex-col">
                            <div class="row flex flex-row w-full">
                                <div class="w-6/12" :class="{'topspace': addpopup}">
                                    <label class="controllabel">Family</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlFamily || 'N/A'}}</div>
                                    <!-- <multiselect
                                        v-else
                                        v-model="customControlObject.controlFamily"
                                        :options="filteredControlFamilyOptions"
                                        :showNoOptions="false"
                                        @search-change="asyncFindControlFamily"
                                        :multiple="false"
                                        :searchable="true"
                                        open-direction="bottom"
                                        :hideArrow="false"
                                        placeholder="Family"
                                        class="custom-multiselect userSelect mt-2"
                                    >
                                        <template v-slot:noResult>
                                            <span class="text-xs">No Families Found</span>
                                        </template>
                                    </multiselect> -->
                                        <div v-else>
                                        <AutoComplete 
                                        v-model="customControlObject.controlFamily"
                                        :suggestions="filteredControlFamilyOptions"
                                        @complete="asyncFindControlFamily"
                                        field="label"
                                        :forceSelection="true"
                                        placeholder="Control Family"
                                        class="p-inputtext-sm systemsstyling  mt-2"
                                        />

                                        </div>
                                    
                                </div>
                                <div class="w-3/6 leftspacing" :class="{'topspace': addpopup}">
                                    <label class="controllabel">Class</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlClass || 'N/A'}}</div>
                                    <!-- <input
                                        v-else
                                        type="text"
                                        class="inputboxstyling mt-2"
                                        @input="v$.customControlObject.controlClass.$touch()"
                                        placeholder="Class"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlClass.$error
                                        }"
                                        v-model.trim="customControlObject.controlClass"
                                    /> -->
                                    <div v-else>
                                        <AutoComplete 
                                        v-model="customControlObject.controlClass"
                                        :suggestions="filteredControlClassOptions"
                                        @complete="asyncFindControlClass"
                                        field="label"
                                        :forceSelection="true"
                                        placeholder="Control Class"
                                        class="p-inputtext-sm systemsstyling  mt-2"
                                        />
                                        </div>
                                    <div v-if="v$.customControlObject.controlClass.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlClass && v$.customControlObject.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </fieldset>
            <div v-if="selectedTabIndex != 2">
                <div class="statuscontainer popupbodycontainer">
                    <div class="row flex flex-row w-full mt-3" :class="{'topspace': addpopup}">
                        <div class="w-6/12">
                            <label class="controllabel">Owner</label>
                            <AutoComplete
                                v-model="controlOwnerSelection"
                                :suggestions="filteredControlOwnerOptions"
                                @complete="asyncFindControlOwner"
                                @item-select="onControlOwnerPicked($event, customControlObject)"
                                optionLabel="label"
                                field="label"
                                :forceSelection="true"
                                :invalid="addpopup && v$.customControlObject.controlOwner.$error"
                                placeholder="Please select one"
                                class="p-inputtext-sm systemsstyling mt-2 w-full"
                            />
                            <div v-if="addpopup && v$.customControlObject.controlOwner.$error" class="text-red-500">
                                <div class="error-text" v-if="v$.customControlObject.controlOwner.required.$invalid">Required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <fieldset :disabled="customControlObject._id">
            <div>
                <div class="statuscontainer popupbodycontainer">

                            <!-- <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Audit Methodology</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlAuditMethodology || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling mt-2"
                                        @input="v$.customControlObject.controlAuditMethodology.$touch()"
                                        placeholder="Audit Methodology"
                                        v-model.trim="customControlObject.controlAuditMethodology"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlAuditMethodology.$error
                                        }"
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlAuditMethodology.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlAuditMethodology && v$.customControlObject.controlAuditMethodology.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div> -->

                            <!-- <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Audit Success Criteria</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlAuditSuccessCriteria || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Audit Success Criteria"
                                        v-model.trim="customControlObject.controlAuditSuccessCriteria"
                                        @input="v$.customControlObject.controlAuditSuccessCriteria.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlAuditSuccessCriteria.$error
                                        }"
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlAuditSuccessCriteria.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlAuditSuccessCriteria && v$.customControlObject.controlAuditSuccessCriteria.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Description</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.Description || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Description"
                                        v-model.trim="customControlObject.Description"
                                        @input="v$.customControlObject.Description.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.Description.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.Description.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.Description && v$.customControlObject.Description.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Task</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlMaintenanceTask || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Task"
                                        v-model.trim="customControlObject.controlMaintenanceTask"
                                        @input="v$.customControlObject.controlMaintenanceTask.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlMaintenanceTask.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlMaintenanceTask.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlMaintenanceTask && v$.customControlObject.controlMaintenanceTask.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Policies</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlPolicies || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Policies"
                                        v-model.trim="customControlObject.controlPolicies"
                                        @input="v$.customControlObject.controlPolicies.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlPolicies.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlPolicies.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlPolicies && v$.customControlObject.controlPolicies.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full " :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Guidance</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlGuidance || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Guidance"
                                        v-model.trim="customControlObject.controlGuidance"
                                        @input="v$.customControlObject.controlGuidance.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlGuidance.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlGuidance.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlGuidance && v$.customControlObject.controlGuidance.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Frameworks</label>
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.controlOptionFrameWork || 'N/A'}}</div>
                                
                                <Select v-else
                                    v-model="customControlObject.controlOptionFrameWork"
                                    :options="frameWorksList"
                                    @change="getFrameworkControls(customControlObject.controlOptionFrameWork)"
                                    placeholder="Please select one"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                        'inputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork === '',
                                        'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork !== ''
                                    }"
                                />
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Controls</label>
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.frameworkControls || 'N/A'}}</div>
                                    <!-- <div v-else > -->
                                        <!-- <AutoComplete 
                                        v-model="customControlObject.frameworkControls"
                                        :suggestions="frameworkControls"
                                        @complete="asyncFrameworkControl"
                                        field="label"
                                        :forceSelection="true"
                                        placeholder="System Category"
                                        class="p-inputtext-sm systemsstyling  mt-2 custom-autocomplete"
                                        /> -->
                                           <div v-else>
                                                <Select 
                                                    v-model="customControlObject.frameworkControls"
                                                    :options="frameworkControls"
                                                    optionValue="value"
                                                    optionLabel="label"
                                                    :disabled="customControlObject.controlOptionFrameWork==''"
                                                    appendTo="self"
                                                    placeholder="Please select one"
                                                    class="w-full custom-multiselect userSelect mt-2"
                                                    :class="{
                                                        'inputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': customControlObject.controlOptionFrameWork !== ''
                                                    }"
                                                />
                                        </div>
                                    </div>

                        </div>
                    </div>
            </fieldset>
        </div>
        <!-- <div class="bottom-7 bg-white h-14 flex justify-end items-center w-full  rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
                <div class="buttonposition flex justify-end items-center px-5 mx-5">
                    <button @click="onCancelAllControls()" :class="customControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary mr-1.5" >Reset</button>
                    <button @click="saveControlsChangeForActivity(10301)" :disabled="clickOnButton" :class="customControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary">Active</button>
                </div>
            </div> -->
             <div v-if="customPopup=true">
                <div class="border-b border-solid border-lightgrey mx-5"></div>
                    <div v-if="!customControlObject._id" class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                            <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustom('cancel')">Reset</button>
                            <button class="btnprimary" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="saveCustomControl(customControlObject)">Save</button>          
                    </div>
            </div>
        <div  v-if="selectedTabIndex == 1 && customControlObject._id">
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                        <button class="btnprimary" type="button" :disabled="!controlOwnerChanged" :class="controlOwnerChanged ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onExistingControlOwnerSelect()">Update</button>
                </div>
        </div>
        <div  v-if="selectedTabIndex == 2">
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                        <!-- <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustom('cancel')">Reset</button> -->
                        <button class="btnprimary" :disabled="clickOnButton" @click="saveControlsChangeForActivity(10301)">Active</button>          
                </div>
        </div>
        <div  v-if="selectedTabIndex==3">
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                        <!-- <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustom('cancel')">Reset</button> -->
                        <button v-if="customControlObject._id" class="btnprimary mr-1.5" type="button" :disabled="!controlOwnerChanged" :class="controlOwnerChanged ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onExistingControlOwnerSelect()">Update</button>
                        <button class="btnprimary" @click="active(customControlObject)">Active</button>          
                </div>
        </div>
    </div>
    </popup>
     <popup v-if="clonePopup" :popUp="clonePopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1 v-if="customCloneControlObject != undefined && customCloneControlObject.classificationType == 3 " class="pl-2">{{customCloneControlObject.controlTitle}}</h1>
                <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customCloneControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Clone Control</h1>
                </div>
                <button class="float-right text-3xl" @click="onCancelbtnCustom('close')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
<div class="flex flex-col h-full">
    <div class="flex-1 overflow-auto">
            <fieldset :disabled="customCloneControlObject._id">
            <div>
                <div class="statuscontainer popupbodycontainer">
                    <div class="formcontainer flex flex-col">
                        <div v-if="addpopup==true" class="row flex flex-row w-full">
                            <div class="w-full mt-3">
                                <label class="controllabel">Source Control</label>
                                <AutoComplete 
                                    v-model="customCloneControlObject.source"
                                    :suggestions="filteredICOptions"
                                    @complete="asyncFindInternalControls"
                                    @item-select="bindOtherFields"
                                    @clear="resetCloneControlFields"
                                    @update:model-value="checkTitleCleared"
                                    optionLabel="label"
                                    optionValue="value" 
                                    field="label"  
                                    panelClass="clone-popup-panel"                                                                                             
                                    :forceSelection="true"
                                    placeholder="Source"
                                    class="p-inputtext-sm custom-multiselect systemsstyling  mt-2"
                                    :class="{ 'p-invalid': v$.customCloneControlObject.source.$error }"
                                    />
                                 <div v-if="v$.customCloneControlObject.source.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.source.required.$invalid">Required</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="addpopup==true" class="row flex flex-row w-full">
                            <div class="w-full mt-3">
                                <label class="controllabel">Control Title</label>
                                <textarea 
                                    type="text-area"
                                    class="inputboxstyling mt-2"
                                    placeholder="Control Title"
                                    :disabled="!customCloneControlObject.source"
                                    @input="v$.customCloneControlObject.controlTitle.$touch()"
                                    v-model.trim="customCloneControlObject.controlTitle"
                                    :class="{
                                        'is-invalid': v$.customCloneControlObject.controlTitle.$error,
                                        'disabled-textarea': !customCloneControlObject.source
                                    }"
                                ></textarea>
                                <div v-if="v$.customCloneControlObject.controlTitle.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.controlTitle.required.$invalid">Required</div>
                                    <div v-else-if="v$.customCloneControlObject.controlTitle && v$.customCloneControlObject.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row w-full"> 
                            <div class="w-6/12 "  :class="{'topspace': addpopup}">
                                <label class="controllabel text-xs">Frequency</label>
                                <div v-if="addpopup==false && (selectedTabIndex!=1|| selectedTabIndex==1)" class="text-sm mt-2 mb-3">{{ dbFrequency.find((item:any) => item.value === customCloneControlObject.controlFrequency)?.key ?? 'N/A' }}</div>
                                <!-- <select v-else class="mt-2" :class="{ 'is-invalid': v$.customCloneControlObject.controlFrequency.$error,'inputboxstylingForSelectAtPopup': customCloneControlObject.controlFrequency === '','stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlFrequency !== '' }" v-model="customCloneControlObject.controlFrequency">
                                    <option value="" selected disabled hidden>Select</option>
                                    <option class="optionColors" v-for="(value, index) in controlFrequencyArray" :key="index" :value="value.id">{{ value.label }}</option>
                                </select> -->
                                <Select v-else
                                    v-model="customCloneControlObject.controlFrequency"
                                    :options="dbFrequency"
                                    optionLabel="key"
                                    optionValue="value"
                                    :disabled="!customCloneControlObject.source"
                                    placeholder="Please select one"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                        'is-invalid': v$.customCloneControlObject.controlFrequency.$error,
                                        'inputboxstylingForSelectAtPopup': customCloneControlObject.controlFrequency === '',
                                    }"
                                    
                                />
                                 <div v-if="v$.customCloneControlObject.controlFrequency.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.controlFrequency.required.$invalid">Required</div>
                                </div> 
                        
                            </div>
                            <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                <label class="controllabel text-xs">Priority</label>
                                <div class="mb-3 mt-2 text-sm" v-if="addpopup==false && (selectedTabIndex!=1|| selectedTabIndex==1)">
                                <div v-if="customCloneControlObject.controlPriority && typeof customCloneControlObject.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2" :class="colorLabelBg(customCloneControlObject.controlPriority)">
                                    <div class="text-xs" :class="colorLabelText(customCloneControlObject.controlPriority)">
                                        {{ getProirityLabel(customCloneControlObject.controlPriority) }}
                                    </div>
                                </div>
                                <div v-else>N/A</div>
                                <!-- {{ dbPriority.find(item => item.value === customCloneControlObject.controlPriority)?.key || 'N/A' }} -->
                                </div>
                                <!-- <select v-else class="mt-2" v-model="customCloneControlObject.controlPriority" :class="{'inputboxstylingForSelectAtPopup': customCloneControlObject.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlPriority !== ''}">
                                    <option value="" selected disabled hidden>Select</option>
                                    <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value.key }}</option>
                                </select> -->
                                    <Select
                                    v-else
                                    v-model="customCloneControlObject.controlPriority"
                                    :options="dbPriority"
                                    optionLabel="key"
                                    optionValue="value"
                                    placeholder="Please select one"
                                    :disabled="!customCloneControlObject.source"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                        'is-invalid': v$.customCloneControlObject.controlPriority.$error,
                                        'inputboxstylingForSelectAtPopup': customCloneControlObject.controlPriority === '',
                                    }"
                                   
                                />
                                <div v-if="v$.customCloneControlObject.controlPriority.$error" class="text-red-500">
                                    <div class="error-text" v-if="v$.customCloneControlObject.controlPriority.required.$invalid">Required</div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="flex flex-row w-full">
                        <div class="w-6/12 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Number</label>
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.clientUniqueId ? customCloneControlObject.clientUniqueId:customCloneControlObject.controlNumber|| 'N/A'}}</div>
                                <input
                                    v-else
                                    type="text"
                                    class="inputboxstyling mt-2 disiableState"
                                    v-model.trim="customCloneControlObject.controlNumber"
                                    placeholder="Number"
                                    disabled
                                />
                            </div>
                         <div class="w-6/12 leftspacing" :class="{'topspace': addpopup}">
                                    <div>
                                    <label class="controllabel">Category</label>
                                    <div> 
                                        <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlType || 'N/A'}}</div>
                                        <!-- <input
                                            v-else
                                            type="text"
                                            class="inputboxstyling"
                                            @input="v$.customCloneControlObject.controlType.$touch()"
                                            
                                            v-model.trim="customCloneControlObject.controlType"
                                            placeholder="Type"
                                            :class="{
                                                'is-invalid': v$.customCloneControlObject.controlType.$error
                                            }"
                                        /> -->
                                            <div v-else>
                                            <AutoComplete 
                                            v-model="customCloneControlObject.controlType"
                                            :suggestions="filteredControlTypeOptions"
                                            @complete="asyncFindControlType"
                                            field="label"
                                            :forceSelection="true"
                                            placeholder="Category"
                                            :disabled="!customCloneControlObject.source"
                                            class="p-inputtext-sm systemsstyling  mt-2"
                                            />
                                        </div>
                                    <div v-if="v$.customCloneControlObject.controlType.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlType && v$.customCloneControlObject.controlType.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <div class="formcontainer flex flex-col">
                            <div class="row flex flex-row w-full">
                                <div class="w-6/12" :class="{'topspace': addpopup}">
                                    <label class="controllabel">Family</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlFamily || 'N/A'}}</div>
                                    <!-- <multiselect
                                        v-else
                                        v-model="customCloneControlObject.controlFamily"
                                        :options="filteredControlFamilyOptions"
                                        :showNoOptions="false"
                                        @search-change="asyncFindControlFamily"
                                        :multiple="false"
                                        :searchable="true"
                                        open-direction="bottom"
                                        :hideArrow="false"
                                        placeholder="Family"
                                        class="custom-multiselect userSelect mt-2"
                                    >
                                        <template v-slot:noResult>
                                            <span class="text-xs">No Families Found</span>
                                        </template>
                                    </multiselect> -->
                                        <div v-else>
                                        <AutoComplete 
                                        v-model="customCloneControlObject.controlFamily"
                                        :suggestions="filteredControlFamilyOptions"
                                        @complete="asyncFindControlFamily"
                                        field="label"
                                        :forceSelection="true"
                                        :disabled="!customCloneControlObject.source"
                                        placeholder="Control Family"
                                        class="p-inputtext-sm systemsstyling  mt-2"
                                        :class="{ 'p-invalid': v$.customCloneControlObject.controlFamily.$error }"
                                        />
                                        <div v-if="v$.customCloneControlObject.controlFamily.$error" class="text-red-500">
                                            <div v-if="v$.customCloneControlObject.controlFamily && v$.customCloneControlObject.controlFamily.restrictCharacters30.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                        </div>

                                        </div>
                                    
                                </div>
                                <div class="w-3/6 leftspacing" :class="{'topspace': addpopup}">
                                    <label class="controllabel">Class</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlClass || 'N/A'}}</div>
                                    <!-- <input
                                        v-else
                                        type="text"
                                        class="inputboxstyling mt-2"
                                        @input="v$.customCloneControlObject.controlClass.$touch()"
                                        placeholder="Class"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.controlClass.$error
                                        }"
                                        v-model.trim="customCloneControlObject.controlClass"
                                    /> -->
                                    <div v-else>
                                        <AutoComplete 
                                        v-model="customCloneControlObject.controlClass"
                                        :suggestions="filteredControlClassOptions"
                                        @complete="asyncFindControlClass"
                                        field="label"
                                        :disabled="!customCloneControlObject.source"
                                        :forceSelection="true"
                                        placeholder="Control Class"
                                        class="p-inputtext-sm systemsstyling  mt-2"
                                        />
                                        </div>
                                    <div v-if="v$.customCloneControlObject.controlClass.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlClass && v$.customCloneControlObject.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="row flex flex-row w-full mt-3" :class="{'topspace': addpopup}">
                                <div class="w-6/12">
                                    <label class="controllabel">Owner</label>
                                    <AutoComplete
                                        v-model="controlOwnerSelection"
                                        :suggestions="filteredControlOwnerOptions"
                                        @complete="asyncFindControlOwner"
                                        @item-select="onControlOwnerPicked($event, customCloneControlObject)"
                                        optionLabel="label"
                                        field="label"
                                        :disabled="!customCloneControlObject.source"
                                        :forceSelection="true"
                                        :invalid="v$.customCloneControlObject.controlOwner.$error"
                                        placeholder="Please select one"
                                        class="p-inputtext-sm systemsstyling mt-2 w-full"
                                    />
                                    <div v-if="v$.customCloneControlObject.controlOwner.$error" class="text-red-500">
                                        <div class="error-text" v-if="v$.customCloneControlObject.controlOwner.required.$invalid">Required</div>
                                    </div>
                                </div>
                         </div>
                         <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Description</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.Description || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Description"
                                        :disabled="!customCloneControlObject.source"
                                        v-model.trim="customCloneControlObject.Description"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.Description.$error,
                                            'disabled-textarea': !customCloneControlObject.source
                                        }" 
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.Description.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.Description && v$.customCloneControlObject.Description.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Tasks</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlMaintenanceTask || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Tasks"
                                        :disabled="!customCloneControlObject.source"
                                        v-model.trim="customCloneControlObject.controlMaintenanceTask"
                                        @input="v$.customCloneControlObject.controlMaintenanceTask.$touch()"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.controlMaintenanceTask.$error,
                                            'disabled-textarea': !customCloneControlObject.source
                                        }"
                                        
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.controlMaintenanceTask.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlMaintenanceTask && v$.customCloneControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full" :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Policies</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlPolicies || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Policies"
                                        :disabled="!customCloneControlObject.source"
                                        v-model.trim="customCloneControlObject.controlPolicies"
                                        @input="v$.customCloneControlObject.controlPolicies.$touch()"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.controlPolicies.$error,
                                            'disabled-textarea': !customCloneControlObject.source
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.controlPolicies.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlPolicies && v$.customCloneControlObject.controlPolicies.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full " :class="{'topspace': addpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Guidance</label>
                                    <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlGuidance || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Guidance"
                                        :disabled="!customCloneControlObject.source"
                                        v-model.trim="customCloneControlObject.controlGuidance"
                                        @input="v$.customCloneControlObject.controlGuidance.$touch()"
                                        :class="{
                                            'is-invalid': v$.customCloneControlObject.controlGuidance.$error,
                                            'disabled-textarea': !customCloneControlObject.source
                                        }"
                                       
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customCloneControlObject.controlGuidance.$error" class="text-red-500">
                                        <div v-if="v$.customCloneControlObject.controlGuidance && v$.customCloneControlObject.controlGuidance.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Frameworks</label>
                                <!-- {{ customCloneControlObject.controlOptionFrameWork }}--{{frameWorksList  }} -->
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.controlOptionFrameWork || 'N/A'}}</div>
                                
                                <Select v-else
                                    v-model="customCloneControlObject.controlOptionFrameWork"
                                    :options="frameWorksList"
                                    :disabled="!customCloneControlObject.source"
                                    @change="getFrameworkControls(customCloneControlObject.controlOptionFrameWork)"
                                    placeholder="Please select one"
                                    class="w-full custom-multiselect userSelect mt-2"
                                    :class="{
                                    'inputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork === '',
                                    'stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork !== ''
                                    }"
                                />
                            </div>
                            <!-- {{ frameworkControls }}--{{ customCloneControlObject.frameworkControls }} -->
                            <div class="w-full col-md-6 " :class="{'topspace': addpopup}">
                                <label class="controllabel">Controls</label>
                                <div v-if="addpopup==false" class="mb-3 mt-2 text-sm">{{ customCloneControlObject.frameworkControls || 'N/A'}}</div>
                                    <!-- <div v-else > -->
                                        <!-- <AutoComplete 
                                        v-model="customCloneControlObject.frameworkControls"
                                        :suggestions="frameworkControls"
                                        @complete="asyncFrameworkControl"
                                        field="label"
                                        :forceSelection="true"
                                        placeholder="System Category"
                                        class="p-inputtext-sm systemsstyling  mt-2 custom-autocomplete"
                                        /> -->
                                           <div v-else>
                                                <Select 
                                                    v-model="customCloneControlObject.frameworkControls"
                                                    :options="frameworkControls"
                                                    optionValue="value"
                                                    optionLabel="label"
                                                    :disabled="customCloneControlObject.controlOptionFrameWork=='' || !customCloneControlObject.source"
                                                    appendTo="self"
                                                    placeholder="Please select one"
                                                    class="w-full custom-multiselect userSelect mt-2"
                                                    :class="{
                                                        'inputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork === '',
                                                        'stylingForInputboxstylingForSelectAtPopup': customCloneControlObject.controlOptionFrameWork !== ''
                                                    }"
                                                />
                                        </div>
                                    </div>

                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <!-- <div  class="bottom-7 bg-white h-14 flex justify-end items-center w-full  rounded-b-sm" style="box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);">
                <div class="buttonposition flex justify-end items-center px-5 mx-5">
                    <button @click="onCancelAllControls()" :class="customCloneControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary mr-1.5" >Reset</button>
                    <button @click="saveControlsChangeForActivity(10301)" :disabled="clickOnButton" :class="customCloneControlObject.length == 0 ? 'btndisabled pointer-events-none' : 'btnprimary'" class="btnprimary">Active</button>
                </div>
            </div> -->
            <div v-if="clonepopup=true">
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div v-if="!customCloneControlObject._id" class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                        <button class="btnprimary mr-1.5" :class="disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustomForCloning('cancel')">Reset</button>
                        <button class="btnprimary" :class="disableStatusForCloneControl ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton" @click="saveCustomControlForCloning(customCloneControlObject)">Save</button>          
                </div>
        </div>
        <div  v-if="selectedTabIndex == 2">
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                        <!-- <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustom('cancel')">Reset</button> -->
                        <button class="btnprimary"  :disabled="clickOnButton" @click="saveControlsChangeForActivity(10301)">Active</button>          
                </div>
        </div>
        <div  v-if="selectedTabIndex==3">
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center  pb-4 pl-5 pt-4 pr-5">
                        <!-- <button class="btnprimary mr-1.5" :class="disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButton"  @click="onCancelbtnCustom('cancel')">Reset</button> -->
                        <button class="btnprimary" @click="active(customControlObject)">Active</button>          
                </div>
        </div>
    </div>
    </popup>
    <popup v-if="controlEditPopup" :popUp ="controlEditPopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1  class="pl-2">{{controlsData?.controlTitle||'N/A'}}</h1>
                <!-- <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Control</h1>
                </div> -->
                <button class="float-right text-3xl" @click="onCancelbtnCustom('close')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
<!-- <div> -->
    <div class="flex flex-col h-full">
        <div class="flex-1 overflow-auto">
            <fieldset>
                <div>
                    <div class="statuscontainer popupbodycontainer">
                        <div class="formcontainer flex flex-col">
                            <div v-if="addControlpopup==true" class="row flex flex-row w-full ">
                                <div class="w-full mt-3">
                                    <label class="controllabel">Title</label>
                                    <!-- <div class="mb-3 mt-2 text-sm">{{ customControlObject.controlTitle || 'N/A'}}</div> -->
                                    <textarea 
                                        type="text-area"
                                        class="inputboxstyling mt-2"
                                        placeholder="Title"
                                        @input="v$.customControlObject.controlTitle.$touch()" 
                                        v-model.trim="customControlObject.controlTitle"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlTitle.$error
                                        }"
                                    ></textarea>
                                    <div v-if="v$.customControlObject.controlTitle.$error" class="text-red-500">
                                        <div class="error-text" v-if="v$.customControlObject.controlTitle.required.$invalid">Required</div>
                                        <div v-else-if="v$.customControlObject.controlTitle && v$.customControlObject.controlTitle.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-3/6" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Frequency</label>
                                        <!-- <div v-if="addControlpopup==true" class="text-sm mt-2 mb-3">{{ controlFrequencyArray.find(item => item.id === controlsData.controlFrequency)?.label ?? 'N/A' }}</div> -->
                                        <!-- <div> -->
                                            <Select 
                                                v-model="controlsEditData.controlFrequency"
                                                :options="dbFrequency"
                                                optionLabel="key"
                                                optionValue="value"
                                                placeholder="Please select one"
                                                class="w-full custom-multiselect userSelect mt-2"
                                                :class="{
                                                    'is-invalid': v$.controlsEditData.controlFrequency.$error,
                                                    'inputboxstylingForSelectAtPopup': customControlObject.controlFrequency === '',
                                                }"
                                            />
                                        <!-- </div> -->
                                        <div v-if="v$.controlsEditData.controlFrequency.$error" class="text-red-500">
                                            <div class="error-text" v-if="v$.controlsEditData.controlFrequency.required.$invalid">Required</div>
                                        </div> 
                                
                                    </div>
                                    
                                    <div class="w-6/12 pl-4" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Priority</label>
                                        <!-- <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">

                                        {{ dbPriority.find(item => item.value === controlsData.controlPriority)?.key || 'N/A' }}
                                        </div> -->
                                        <!-- <div>
                                            
                                        </div> -->
                                        <!-- <select  class="mt-2" v-model="controlsEditData.controlPriority" :class="{'is-invalid': v$.controlsEditData.controlPriority.$error,'inputboxstylingForSelectAtPopup': controlsEditData.controlPriority === '','stylingForInputboxstylingForSelectAtPopup': controlsEditData.controlPriority !== ''}">
                                            <option value="" selected disabled hidden>Select</option>
                                            <option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value?.key }}</option>
                                        </select> -->
                                        <Select 
                                            v-model="controlsEditData.controlPriority"
                                            :options="dbPriority"
                                            optionLabel="key"
                                            optionValue="value"
                                            placeholder="Please select one"
                                            class="w-full custom-multiselect userSelect mt-2"
                                            :class="{
                                                'is-invalid': v$.controlsEditData.controlPriority.$error,
                                                'inputboxstylingForSelectAtPopup': controlsEditData.controlPriority === '',
                                            }"
                                        />
                                        <div v-if="v$.controlsEditData.controlPriority.$error" class="text-red-500">
                                            <div class="error-text" v-if="v$.controlsEditData.controlPriority.required.$invalid">Required</div>
                                        </div> 
                                    </div>
                                
                                </div>
                            </div>

                            <div class="formcontainer flex flex-col ">
                                <div class="row flex flex-row w-full mt-3">
                                <div class="w-6/12" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Number</label>
                                        <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ customControlObject.clientUniqueId || 'N/A'}}</div>
                                        <input
                                            v-else
                                            type="text"
                                            class="inputboxstyling mt-2"
                                            v-model.trim="customControlObject.clientUniqueId"
                                            @input="v$.customControlObject.clientUniqueId.$touch()"
                                            placeholder="Number"
                                            disabled
                                        />
                                    </div>
                                    <div class="w-6/12 pl-4" :class="{'topspace': addControlpopup}">
                                        <div>
                                        <label class="controllabel">Category</label>
                                        <div class="mt-2"> 
                                            <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlType || 'N/A'}}</div>
                                            <input
                                                v-else
                                                type="text"
                                                class="inputboxstyling"
                                                @input="v$.customControlObject.controlType.$touch()"
                                                
                                                v-model.trim="customControlObject.controlType"
                                                placeholder="Type"
                                                :class="{
                                                    'is-invalid': v$.customControlObject.controlType.$error
                                                }"
                                            />
                                        <div v-if="v$.customControlObject.controlType.$error" class="text-red-500">
                                            <div v-if="v$.customControlObject.controlType && v$.customControlObject.controlType.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full">
                                    <div class="w-6/12" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Family</label>
                                        <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlFamily || 'N/A'}}</div>
                                        <multiselect
                                            v-else
                                            v-model="customControlObject.controlFamily"
                                            :options="filteredControlFamilyOptions"
                                            :showNoOptions="false"
                                            @search-change="asyncFindControlFamily"
                                            :multiple="false"
                                            :searchable="true"
                                            open-direction="bottom"
                                            :hideArrow="false"
                                            placeholder="Family"
                                            class="custom-multiselect userSelect mt-2"
                                        >
                                            <template v-slot:noResult>
                                                <span class="text-xs">No Families Found</span>
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="w-3/6 pl-4" :class="{'topspace': addControlpopup}">
                                        <label class="controllabel">Class</label>
                                        <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlClass || 'N/A'}}</div>
                                        <input
                                            v-else
                                            type="text"
                                            class="inputboxstyling mt-2"
                                            @input="v$.customControlObject.controlClass.$touch()"
                                            placeholder="Class"
                                            :class="{
                                                'is-invalid': v$.customControlObject.controlClass.$error
                                            }"
                                            v-model.trim="customControlObject.controlClass"
                                        />
                                        <div v-if="v$.customControlObject.controlClass.$error" class="text-red-500">
                                            <div v-if="v$.customControlObject.controlClass && v$.customControlObject.controlClass.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row flex flex-row w-full mt-3" :class="{'topspace': addControlpopup}">
                                <div class="w-6/12">
                                    <label class="controllabel">Owner</label>
                                    <AutoComplete
                                        v-model="controlOwnerSelection"
                                        :suggestions="filteredControlOwnerOptions"
                                        @complete="asyncFindControlOwner"
                                        @item-select="onControlOwnerPicked($event, controlsEditData)"
                                        optionLabel="label"
                                        field="label"
                                        :forceSelection="true"
                                        placeholder="Please select one"
                                        class="p-inputtext-sm systemsstyling mt-2 w-full"
                                    />
                                </div>
                            </div>
<!-- 
                            <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Audit Methodology</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlAuditMethodology || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling mt-2"
                                        @input="v$.customControlObject.controlAuditMethodology.$touch()"
                                        placeholder="Audit Methodology"
                                        v-model.trim="customControlObject.controlAuditMethodology"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlAuditMethodology.$error
                                        }"
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlAuditMethodology.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlAuditMethodology && v$.customControlObject.controlAuditMethodology.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div> -->

                            <!-- <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Audit Success Criteria</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlAuditSuccessCriteria || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Audit Success Criteria"
                                        v-model.trim="customControlObject.controlAuditSuccessCriteria"
                                        @input="v$.customControlObject.controlAuditSuccessCriteria.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlAuditSuccessCriteria.$error
                                        }"
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlAuditSuccessCriteria.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlAuditSuccessCriteria && v$.customControlObject.controlAuditSuccessCriteria.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Description</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.Description || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Description"
                                        v-model.trim="customControlObject.Description"
                                        @input="v$.customControlObject.Description.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.Description.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.Description.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.Description && v$.customControlObject.Description.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Tasks</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlMaintenanceTask || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Maintenance Task"
                                        v-model.trim="customControlObject.controlMaintenanceTask"
                                        @input="v$.customControlObject.controlMaintenanceTask.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlMaintenanceTask.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlMaintenanceTask.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlMaintenanceTask && v$.customControlObject.controlMaintenanceTask.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full" :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Policies</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlPolicies || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Policies"
                                        v-model.trim="customControlObject.controlPolicies"
                                        @input="v$.customControlObject.controlPolicies.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlPolicies.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlPolicies.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlPolicies && v$.customControlObject.controlPolicies.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row flex flex-row w-full " :class="{'topspace': addControlpopup}">
                                <div class="w-full">
                                    <label class="controllabel">Guidance</label>
                                    <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlGuidance || 'N/A'}}</div>
                                    <textarea
                                        v-else
                                        type="text-area"
                                        class="inputboxstyling h-24 mt-2"
                                        placeholder="Guidance"
                                        v-model.trim="customControlObject.controlGuidance"
                                        @input="v$.customControlObject.controlGuidance.$touch()"
                                        :class="{
                                            'is-invalid': v$.customControlObject.controlGuidance.$error
                                        }"
                                    
                                    >
                                    </textarea>
                                    <div v-if="v$.customControlObject.controlGuidance.$error" class="text-red-500">
                                        <div v-if="v$.customControlObject.controlGuidance && v$.customControlObject.controlGuidance.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addControlpopup}">
                                <label class="controllabel">Frameworks</label>
                                <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.controlOptionFrameWork || 'N/A'}}</div>
                                <multiselect
                                    v-else
                                    v-model="customControlObject.controlOptionFrameWork"
                                    @select="getFrameworkControls(customControlObject.controlOptionFrameWork)"
                                    :multiple="false"
                                    :options="frameWorksList"
                                    :searchable="true"
                                    open-direction="bottom"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :show-labels="false"
                                    placeholder="Frameworks"
                                    class="custom-multiselect mt-2"
                                >
                                    <template v-slot:noResult>
                                        <span class="text-xs">No Frameworks Found</span>
                                    </template>
                                </multiselect>
                            </div>

                            <div class="w-full col-md-6 " :class="{'topspace': addControlpopup}">
                                <label class="controllabel">Controls</label>
                                <div v-if="addControlpopup==false" class="mb-3 mt-2 text-sm">{{ controlsData.frameworkControls || 'N/A'}}</div>
                                <multiselect
                                    v-else
                                    v-model="customControlObject.frameworkControls"
                                    :multiple="false"
                                    :options="frameworkControls"
                                    :searchable="true"
                                    open-direction="bottom"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    placeholder="Controls"
                                    class="custom-multiselect mt-2"
                                    
                                >
                                    <template v-slot:noResult>
                                        <span class="text-xs">No Controls Found</span>
                                    </template>
                                </multiselect>
                            </div>

                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div>
            <div class="border-b border-solid border-lightgrey mx-5"></div>
                <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
                <button class="btnprimary mr-1.5" :class="JSON.stringify(controlsEditData)!==JSON.stringify(dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none'"  @click="onCancelbtnCustom('activecancel')">Reset</button>
                <button class="btnprimary" :class="JSON.stringify(controlsEditData)!==JSON.stringify(dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="editCustomControl(controlsEditData,'edit')">Save</button>          
            </div>
        </div>
</div>
    </popup>
     <popup v-if="deActivatingPopup" :popUp ="deActivatingPopup">
        <template v-slot:header>
            <div class="flex items-center justify-between py-4 pl-2 pr-4 rounded">
                <h1  class="pl-2">{{controlsData?.controlTitle||'N/A'}}</h1>
                <!-- <div v-else class="pl-2">
                    <h1 v-if="addpopup==false" >{{customControlObject.controlTitle || 'N/A'}}</h1>
                    <h1 v-else>Control</h1>
                </div> -->
                <button class="float-right text-3xl" @click="onCancelbtnCustom('deactivateclose')">
                    <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                </button>
            </div>
        </template>
<!-- <div> -->
        <div class="flex flex-col h-full">
        <div class="flex-1 overflow-auto">
            <fieldset>
                <div>
                    <div class="statuscontainer popupbodycontainer">
                        <div class="formcontainer flex flex-col">
                            <div class="row flex flex-row w-full upperspacing">
                                <div class="w-full">
                                    <label class="controllabel">Reason/Justification for Deactivating the control</label>
                                    <textarea
                                    type="text-area"
                                    class="inputboxstyling mt-2"
                                    placeholder="Reason/Justification for Deactivating the control"
                                    v-model="deActiveControlObject.justification"
                                    :class="{
                                        'is-invalid': v$.deActiveControlObject.justification.$error
                                        }"                                    
                                    > </textarea>
                                    <div v-if="v$.deActiveControlObject.justification.$error" class="text-red-500">
                                    <div class="error-text text-xs" v-if="v$.deActiveControlObject.justification.required.$invalid">Required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
<div>
    <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div  class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
        <button
            class="btnprimary mr-1.5"
            :class="isObjectEmpty(deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none'"
            @click="onCancelbtnCustom('deactivecancel')"
        >
            Reset
        </button>
        <button class="btnprimary" 
            :class="isObjectEmpty(deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none'"
        @click="editCustomControl(deActiveControlObject,'deActive')"
        >
        Save
        </button>          
        </div>

        </div>
    </div>
<!-- </div> -->
    </popup>

    <MessageDialog
        v-model:visible="showMessageDialog"
        :activeControls="[]"
        :mode="messageDialogMode"
        :tasks="inProgressTasks"
        loadingMessage="Inactivating Control please wait a moment"
        @cancel="onMessageDialogCancel"
        @ok="onMessageDialogOk"
        @ok-tasks="onMessageDialogOkTasks"
    />

</template>

<style scoped>
:deep(.custom-multiselect .p-select-overlay) {
  width: 500px !important;
}

.action-button-container {
  position: relative;
  display: inline-block;
}
/* Dropdown positioning classes */
.dropdown-up {
  bottom: calc(100% + 5px);
  position: absolute;
  right: 0;
  z-index: 999;
  background: white;
  min-width: 150px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.main-table th,
.main-table td {
  min-width: 130px; 
}
.actionStyle{
    width:5%;
}
.dropdown-down {
  top: calc(100% + 5px);
  position: absolute;
  right: 0;
  z-index: 999;
  background: white;
  min-width: 150px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Card and list item styling */
.card {
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 100px;
  width: max-content;
}

.card li {
  /* padding: 8px 12px; */
  /* padding-left:10px; */
  padding-right:10px;
  white-space: nowrap;
  border-bottom: 1px solid #e9e9e9;
}

.card li:hover {
  background-color: #f5f5f5;
}

.card li:last-child {
  border-bottom: none;
}

/* Keep your existing table styles */
.lastChild:last-child {
    border: 0px;
}
.progress{
    background: #1976d2 !important;
    z-index: 1;
    top: 2px;
}
.noScrollbar::-webkit-scrollbar {
  display: none;
}

.noScrollbar {
  -ms-overflow-style: none; 
  scrollbar-width: none; 
}
.action-button {
  background-color: white;
  color: black;
  border: white;
}
.action-button:hover{
    background-color: #f9f9fb !important;
    color: black !important;
    border: white !important;
}

.tabControlMapping {
  height: calc(100vh - 255px); 
}
.mapping-modal .tabControlMapping {
  height: 100%;
  overflow: hidden;
} 
.fullText{
    white-space: break-spaces;
    font-size: 12px;
}
table {
  /* table-layout: fixed; */
  /* width: 100%; */
  background: #FFFFFF;
}
.w-40 {
    width: 140px;
}
.top-24{
    position: absolute;
    top: 128px;
}
.w-10 {
    width: calc(100% - 2.5rem);
}
.nonEmptyTable tr:last-child {
  border-bottom: 1px solid #e9e9e9;
}
.table-ellipsis {
  display:-webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.tab-container {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  gap: 60px !important; 
}
.midHead {
    width: 160px !important;
}
.widthForSelect{
    width : 100% !important;
}
.redBorder {
	border: 1px solid red !important;
	border-radius: 5px !important;
}
.optionColors{
   color : #4D4D4D !important;
}
.borderRed {
    border: 1px solid red !important;
}
th {
  background-color: #FFFFFF;
  cursor: default;
  display: table-cell;
  font-size: 14px !important;
  font-weight: 600;
  height: 60px;
  padding: 0px 15px;
  /* border-bottom: 1px solid #e9e9e9 !important; */
  text-align: left;
  color: black;
 
}
td {
  font-size: 12px;
  font-weight: 400;
  height: 60px !important;
  padding: 0px 15px ;
  text-align: left;
  text-indent: 0px;
  margin: auto;
  box-sizing: border-box;
  color: black;
  border-bottom:0px;
}
.topspace{
    margin-top: 12px;
}
:deep(.p-tabpanels){
    padding-bottom:0px !important;
}
/* .heightOfCard{
    width:100%;
    height:450px;
} */
 @media only screen and (min-width: 320px) and  (max-width:650px) {
    :deep(.p-tablist-tab-list){
      width: max-content !important;
    }
  }
</style>
<script lang="ts">
import _ from 'lodash';
import popup from '@/components/popup.vue';
import useVuelidate from '@vuelidate/core';
import { required, helpers, requiredIf, email } from '@vuelidate/validators';
const numeric = helpers.regex(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);
import { emitter, toast } from '@/main';
import store from '@/store';
import { mapGetters } from 'vuex';
import { defineComponent } from 'vue';
import breadCrumb from '@/components/breadCrumb.vue';
import toolTip from '@/components/toolTip.vue';
import pagination from '@/components/pagination.vue';
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import dotsLoader from '@/components/dotsLoader.vue';
import AutoComplete from 'primevue/autocomplete';
const restrictCharacters100 = helpers.regex(/^[\s\S]{0,100}$/);
const restrictCharacters300 = helpers.regex(/^.{0,300}$/);
const restrictCharacters1000 = helpers.regex(/^[\s\S]{0,1000}$/);
const restrictCharacters30 = helpers.regex(/^.{0,30}$/);
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Select from 'primevue/select';
import Menu from 'primevue/menu';
import Button from 'primevue/button';
import { v4 as uuidv4 } from "uuid";
import MessageDialog from '@/components/messageDialog.vue';
import { columnResizeMixin } from '@/mixins/columnResizeMixin';

export default defineComponent({
    mixins: [columnResizeMixin],
    props: {
        id: { type: [String, Number], default: null },
        modalMode: { type: Boolean, default: false },
    },
    emits: ['header-info', 'open-nested'],
    data(): any {
        return {
            v$: useVuelidate(),
            selectedTabObj: { displayName: 'Process', name: 'Process', id: 0 },
            carouselHead: [
                { displayName: 'Details', name: 'projectInfo', id: 0 },
                { displayName: 'Active Controls', name: 'activatedControls', id: 1 },
                { displayName: 'All Controls', name: 'allControls', id: 2 },
                { displayName: 'Inactive Controls', name: 'allControls', id: 3 },
                { displayName: 'History', name: 'allControls', id: 4 },
            ],
            activityObj:{},
            addpopup:false,
            isMenuVisible:false,
            addControlpopup:false,
            selectedTabIndex: null,
            showFilters: false,
            sideButton: false,
            clickOnButton: false,
            clonePopup:false,
            optionsForInternalControls:[],
            filteredICOptions:[],
            dummyCustomCloneObj:{},
           
            tenants: [],
            tenantsSelect: [],
            orgUsersList: [],
            usersList: [],
            optionsUserArray: [],
            presentActivityObj: {},
            dummycustomControlObject:{},
            tabDataLoading:false,

            allControlHeaders:['controlNumber','controlTitle','controlFamily','controlClass','classificationType','controlPriority'],
            InactiveControlHeaders:['clientUniqueId','controlTitle','createdAt','controlFrequency','classificationType','controlPriority'],
            tableProps1:{
                headerNames:[{key:'controlNumber',value:'ID'},{key:'controlTitle',value:'Title'},{key:'controlFamily',value:'Family'},{key:'controlClass',value:'Class'},{key:'classificationType',value:'Type'},{key:'controlPriority',value:'Priority'}],
                
                headerWidth:[{key:'controlNumber',value:'w-[10%]'},{key:'controlTitle',value:'w-[20%]'},{key:'controlFamily',value:'w-[15%]'},{key:'controlClass',value:'w-[15%]'},{key:'classificationType',value:'w-[10%]'},{key:'controlPriority',value:'w-[10%]'}],

                innerHeaderWidth:[{key:'controlNumber',value:'w-[10%]'},{key:'controlTitle',value:'w-[20%]'},{key:'controlFamily',value:'w-[15%]'},{key:'controlClass',value:'w-[15%]'},{key:'classificationType',value:'w-[10%]'},{key:'controlPriority',value:'w-[10%]'}],
            },

            activeControlHeaders:['clientUniqueId','controlTitle','createdAt','controlFrequency','classificationType','controlPriority','actionButtonForControls'],
            // allControlHeaders:['clientUniqueId','controlTitle','createdAt','controlFrequency','classificationType','controlPriority'],
            tableProps0:{
                headerNames:[{key:'clientUniqueId',value:'CID'},{key:'controlTitle',value:'Title'},{key:'createdAt',value:'Activated On'},{key:'controlFrequency',value:'Frequency'},{key:'classificationType',value:'Type'},{key:'controlPriority',value:'Priority'}],
                
                headerWidth:[{key:'clientUniqueId',value:'w-[10%]'},{key:'controlTitle',value:'w-[30%]'},{key:'createdAt',value:'w-[20%]'},{key:'controlFrequency',value:'w-[10%]'},{key:'classificationType',value:'w-[10%]'},{key:'controlPriority',value:'w-[10%]'},{key:'actionButtonForControls',value:'actionStyle'}],

                innerHeaderWidth:[{key:'clientUniqueId',value:'w-[10%]'},{key:'controlTitle',value:'w-[20%]'},{key:'createdAt',value:'w-[100%]'},{key:'controlFrequency',value:'w-[10%]'},{key:'classificationType',value:'w-[10%]'},{key:'controlPriority',value:'w-[10%]'}],
            },
            tableProps2:{
                headerNames:[{key:'clientUniqueId',value:'CID'},{key:'controlTitle',value:'Title'},{key:'createdAt',value:'Activated On'},{key:'controlFrequency',value:'Frequency'},{key:'classificationType',value:'Type'},{key:'controlPriority',value:'Priority'}],
                
                headerWidth:[{key:'clientUniqueId',value:'w-20'},{key:'controlTitle',value:'w-44'},{key:'createdAt',value:'w-24'},{key:'controlFrequency',value:'w-36'},{key:'classificationType',value:'w-32'},{key:'controlPriority',value:'w-1/6'},{key:'actionButtonForControls',value:'actionStyle'}],

                innerHeaderWidth:[{key:'clientUniqueId',value:'w-20'},{key:'controlTitle',value:'w-44'},{key:'createdAt',value:'w-20'},{key:'controlFrequency',value:'w-28'},{key:'classificationType',value:'w-28'},{key:'controlPriority',value:'w-28'}],
            },
            
           
            routesArray: [],

            allControlsList: [],
            allControlsListDisplay:[],
            allControlsListDummy:[],

            activeControlsList: [],
            activeControlsListDisplay:[],
            activeControlsListDummy:[],

            checkedAllControls: [],
            selectAllOptionAllControls: false,

            selectAllOptionActiveControls:false,
            checkedActiveControls:[],
            defaultCheckedActiveControls:[],
            deActiveControlObject:{
                justification:'',
                forceUpdate:''
            },
            dummyDeActivateControlObject:{},
            pop: false,
            styling: { left: '', bottom: '' },
            tipText: '',
            tipColumn: '',
            tipIndex: '',
            
            className: '',
            classSort: '',
            currentSort: 'name',
            currentSortDir: 'asc',

            pageSize: 20,
            currentPage: 1,
            dynamicPagination: '',
            allFilters: {
                //classificationType:'',
                //controlPriority:'',
                //controlFrequency:''
            },

            controlTypeValues:[
                {
                    id:10603,
                    value:'Custom'
                },
                {
                    id:10604,
                    value:'Built-in'
                }
            ],
            controlDeactiveOptions:[
                {
                    id:2,
                    value:'Deactivate'
                },
                {
                    id :3,
                    value:'kpi'
                }
			],
            controlActiveOptions:[
			    {
                    id: 1,
                    value: 'Edit',
                },
                {
                    id:2,
                    value:'Activate'
                }
			],
            activeValues: [
				{
					id: 1,
					value: 'Active'
				},
				{
					id: 2,
					value: 'Inactive'
				}
			],
            controlFrequencyArray: [
				{ label: 'Daily', id: 1 },
				{ label: 'Weekly', id: 2 },
				{ label: 'Monthly', id: 3 },
				{ label: 'Quarterly', id: 4 },
				{ label: 'Semi Annualy', id: 5 },
				{ label: 'Annualy', id: 6 },
				{ label: 'Transactional', id: 7 },
			],
             projectTypeOptions : [
				{
					label:'Customer',
					value:10703

				},
				{
					label:'Internal',
					value:10704

				}
			],priorityData: [
				{
                    id: 1,
                    value: 'P1'
                },
				{
                    id: 2,
                    value: 'P2'
                },
				{
                    id: 3,
                    value: 'P3'
                },
				{
                    id: 4,
                    value: 'P4'
                },
                {
                    id: 5,
                    value: 'P5'
                },
            ],severitydata:[
                   
                {
                    id:1,
                    value:'Very Low'
                },
                {
                    id:2,
                    value:'Low'
                },
                {
                    id:3,
                    value:'Moderate'
                },
                {
                    id:4,
                    value:'High'
                },
                {
                    id:5,
                    value:'Very High'
                }
                
                    ],

          
            visibleTabs: [], // Tabs visible on screen
            currentGroupIndex: 0, // Current group index for small screens
            tabsPerGroup: 3, // Number of tabs per group for small screens
            isSmallScreen: false, // Flag for screen size
            canScrollLeft: false, // Whether tabs can scroll left
            canScrollRight: true, // Whether tabs can scroll right
            totalGroups: 0, // Total number of groups for small screens

            toolTipActive : false,
            toolTipText : '',
            dataLoading:true,

            isSidebarToggle:true,

            customControlObject: {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                controlGuidance: "",
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                Description:"",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            },
            customCloneControlObject: {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                source: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            },
            dummyCustomObj:{},
            customPopup:false,
            controlEditPopup:false,
            frameWorksList:[],
            frameJson:{},
            frameworkControls:[],
            filteredControlFamilyOptions:[],
            filteredControlClassOptions:[],
            filteredControlOwnerOptions:[],
            controlOwnerSelection: null,
            existingControlOwner: null,
            filteredControlTypeOptions:[],
            ControlFamilyArray:[],

            totalOrgControls:[],
            activeFrameworks:[],
            dropdownDirection:{},
            showBlockindex:'',
            showBlock: false,
            showDropdown: false,
            controlsData:[],
            controlsEditData:{},
            dummyControlObj:{},
            deActivatingPopup:false,
            dummyObjForControlDeactivate:{},
            workLogObject: [],
            newHistory: true,
            allFrameworkControls:[],
            ControlTypeArray:[],
            controlClassArray:[],
            customControl:[],
            entitesDataArray:[],
            tableRow:[],
            presentProjectObj:{},
            showMessageDialog: false,
            dialogTitle: '',
            dialogMessage: '',
            inProgressTasks: [] as any[],
            pendingDeactivateRequest: null as null | { scopeId: any; inactiveType: number; payload: any },
            messageDialogMode: 'confirm' as 'confirm' | 'loading' | 'success' | 'tasks',
        };
    },
    components: {
        popup,
        Multiselect,
        breadCrumb,
        toolTip,
        pagination,
        dotsLoader,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        Select,
        AutoComplete,
        Menu,
        Button,
        MessageDialog
    },
    validations() {
        return {
            customControlObject:{
                controlTitle: { required ,restrictCharacters100},
                controlFrequency: { required },
                controlPriority:{ required },
                controlOwner: { required },
                controlClass: { restrictCharacters300 },
                // controlFamily: { restrictCharacters30 },
                Description:{restrictCharacters1000},
                controlGuidance: { restrictCharacters1000 },
                controlAuditMethodology: { restrictCharacters300 },
                controlAuditSuccessCriteria: { restrictCharacters300 },
                controlMaintenanceTask: { restrictCharacters1000 },
                controlPolicies: { restrictCharacters1000 },
                controlType: { restrictCharacters300 },
            },
            customCloneControlObject:
            {
                source: { required },
                controlTitle: { required ,restrictCharacters100},
                controlFrequency: { required },
                controlPriority:{ required },
                controlOwner: { required },
                controlClass: { restrictCharacters300 },
                controlFamily: { restrictCharacters300 },
                Description:{restrictCharacters1000},
                controlGuidance: { restrictCharacters1000 },
                controlMaintenanceTask: { restrictCharacters1000 },
                controlPolicies: { restrictCharacters1000 },
                controlType: { restrictCharacters300 },
            },
            controlsEditData:{
                controlPriority:{required},
                controlFrequency:{required}
            },
            deActiveControlObject:{
                justification:{required}
            }
        };
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            dbPriority:'dbPriority',
            dbSeverity:'dbSeverity',
            dbFrequency:'dbFrequency'
        }),
    currentId(): any {
        return this.id || this.$route.params['id'];
    },
    controlOwnerChanged(): boolean {
        const selected = this.controlOwnerSelection;
        if (!selected || typeof selected !== 'object' || selected.value === undefined || selected.value === null || selected.value === '') {
            return false;
        }
        const current = this.existingControlOwner;
        if (current === undefined || current === null || current === '') {
            return true;
        }
        return String(selected.value) !== String(current);
    },
    filteredHeaders():any {
    if (this.selectedTabIndex === 3) {
      return this.activeControlHeaders.filter((header:any) => header !== 'actionButtonForControls');
    }
    return this.activeControlHeaders;
  },
        sortedDataAllControls: function (): any {
            return [...this.allControlsListDisplay]
                .filter((row: any) => {
                    for (const key in this.allFilters) {
                        const inputValue = this.allFilters[key];
                        if (inputValue !== '' && row[key]) {
                            if (row[key] == 'N/A') {
                                return false;
                            } 
                            if (Number.isInteger(row[key])) {
                                if (row[key] !== Number(inputValue)) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },

        sortedDataActiveControls: function (): any {
            return [...this.activeControlsListDisplay]
                .filter((row: any) => {
                    for (const key in this.allFilters) {
                        const inputValue = this.allFilters[key];
                        if (inputValue !== '' && row[key]) {
                            if (row[key] == 'N/A') {
                                return false;
                            } 
                            if (Number.isInteger(row[key])) {
                                if (row[key] !== Number(inputValue)) {
                                    return false;
                                }
                            } else {
                                if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
                                    return false;
                                }
                            }
                        }
                    }
                    return true;
                })
                .sort((a, b) => {
                    let modifier = 1;
                    if (this.currentSortDir === 'desc') modifier = -1;
                    if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                })
                .filter((row, index) => {
                    this.dynamicPagination = index + 1;
                    let start = (this.currentPage - 1) * this.pageSize;
                    let end = this.currentPage * this.pageSize;
                    if (index >= start && index < end) return true;
                });
        },

        disableStatus: function (): any {
			let disableStatusCondition;

            if(this.customControlObject._id){
                if (JSON.stringify(this.customControlObject) == JSON.stringify(this.dummyCustomObj)) {
					disableStatusCondition = false;
				} else {
					disableStatusCondition = true;
				}
            }else{
                let val: any = [];
                Object.values(this.customControlObject).forEach((value: any) => {
                    val.push(value);
                });
                for (let n of val) {
                    if (n != '' && n!=this.customControlObject.controlNumber) {
                        disableStatusCondition = true;
                    }
                }
            }

			return disableStatusCondition;
		},
        disableStatusForCloneControl: function (): any {
			let disableStatusCondition;

            if(this.customCloneControlObject._id){
                if (JSON.stringify(this.customCloneControlObject) == JSON.stringify(this.dummyCustomCloneObj)) {
					disableStatusCondition = false;
				} else {
					disableStatusCondition = true;
				}
            }else{
                let val: any = [];
                Object.values(this.customCloneControlObject).forEach((value: any) => {
                    val.push(value);
                });
                for (let n of val) {
                    if (n != '' && n != null && !(Array.isArray(n) && n.length == 0) && n!=this.customCloneControlObject.controlNumber) {
                        disableStatusCondition = true;
                    }
                }
            }
			return disableStatusCondition;
		},
        arraysAreEqual: function (): any {
            const sortedArray1 = [...this.checkedActiveControls].sort();
            const sortedArray2 = [...this.defaultCheckedActiveControls].sort();
            
            if (sortedArray1.length !== sortedArray2.length) {
                return false;
            }

            for (let i = 0; i < sortedArray1.length; i++) {
                if (sortedArray1[i] !== sortedArray2[i]) {
                return false;
                }
            }

            return true;
        }
    },
    methods: {
        parseInProgressTasks(data: any): any[] {
            let parsed = data;
            if (typeof parsed === 'string') {
                const jsonStart = parsed.indexOf('[');
                if (jsonStart >= 0) {
                    try {
                        parsed = JSON.parse(parsed.slice(jsonStart));
                    } catch {
                        parsed = [];
                    }
                } else {
                    parsed = [];
                }
            }
            const list = Array.isArray(parsed)
                ? parsed
                : Array.isArray(parsed?.tasks)
                    ? parsed.tasks
                    : Array.isArray(parsed?.data)
                        ? parsed.data
                        : [];
            return list.map((task: any) => ({
                taskId: task?.taskId ?? task?.id ?? 'N/A',
                taskTitle: task?.taskTitle ?? task?.title ?? task?.TaskName ?? 'N/A',
                dueDate: task?.dueDate,
                plannerTaskId: task?.plannerTaskId,
                _id: task?._id,
                status: task?.status ?? task?.statusCode,
                statusCode: task?.statusCode ?? task?.status,
            }));
        },
        openInProgressTasksDialog(data: any) {
            const tasks = this.parseInProgressTasks(data);
            if (tasks.length === 0) {
                return;
            }
            this.inProgressTasks = tasks;
            this.dialogMessage = data;
            this.messageDialogMode = 'tasks';
            this.showMessageDialog = true;
        },
        onMessageDialogCancel() {
            this.showMessageDialog = false;
            this.customPopup=false;
            this.messageDialogMode = 'confirm';
            this.inProgressTasks = [];
            this.pendingDeactivateRequest = null;
        },
        onMessageDialogOk() {
            this.showMessageDialog = false;
            this.messageDialogMode = 'confirm';
            this.dialogMessage = '';
            this.inProgressTasks = [];
        },
        async onMessageDialogOkTasks() {
            if (!this.pendingDeactivateRequest || this.inProgressTasks.length === 0) {
                this.onMessageDialogCancel();
                return;
            }
            const { scopeId, inactiveType, payload } = this.pendingDeactivateRequest;
            this.messageDialogMode = 'loading';
            try {
                await this.$http.post(
                    `${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_PLANNER_WORKFLOW_ID}/planner/tasks/terminate`,
                    {
                        tasks: this.inProgressTasks,
                        updatedBy: this.userInfo._id,
                        updatedAt: new Date(),
                    }
                );
                const retryPayload = {
                    ...payload,
                    forceUpdate: true,
                };
                await this.$http.post(
                    `${process.env.VUE_APP_MONITOR_API}/api/org/${scopeId}/${inactiveType}/control/inactive`,
                    retryPayload
                );
                toast.info('Saved', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true,
                });
                this.deActivatingPopup = false;
                this.customPopup = false;
                this.dummyDeActivateControlObject = {
                    justification: '',
                    forceUpdate: '',
                };
                this.deActiveControlObject = {
                    justification: '',
                    forceUpdate: '',
                };
                this.getActiveControlsForActivity();
            } catch (e: any) {
                toast.error('Failed to terminate tasks or deactivate control', {
                    timeout: 2000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true,
                });
            } finally {
                this.showMessageDialog = false;
                this.messageDialogMode = 'confirm';
                this.dialogMessage = '';
                this.inProgressTasks = [];
                this.pendingDeactivateRequest = null;
            }
        },
        getProjectType(data:any){
            let matchedProject = this.projectTypeOptions.find((proj:any)=>proj.value==data);
            if(matchedProject!=undefined){
                return matchedProject.label
            }
            else{
                return 'N/A'
            }
        },
        checkTitleCleared(value: any) {
            if (value) {
                return;
            }
            this.resetCloneControlFields();
        },
        resetCloneControlFields() {
            const controlNumber = this.customCloneControlObject.controlNumber;
            this.customCloneControlObject.controlTitle = '';
            this.customCloneControlObject.controlType = '';
            this.customCloneControlObject.controlFamily = '';
            this.customCloneControlObject.controlClass = '';
            this.customCloneControlObject.controlOwner = '';
            this.controlOwnerSelection = null;
            this.filteredControlOwnerOptions = [];
            this.customCloneControlObject.controlDescription = '';
            this.customCloneControlObject.Description = '';
            this.customCloneControlObject.controlMaintenanceTask = '';
            this.customCloneControlObject.controlPolicies = '';
            this.customCloneControlObject.controlGuidance = '';
            this.customCloneControlObject.controlFrequency = '';
            this.customCloneControlObject.controlPriority = '';
            this.customCloneControlObject.controlOptionFrameWork = '';
            this.customCloneControlObject.frameworkControls = '';
            this.customCloneControlObject.frameworks = [];
            this.customCloneControlObject.controlAuditMethodology = '';
            this.customCloneControlObject.controlAuditSuccessCriteria = '';
            this.customCloneControlObject.controlNumber = controlNumber;
            if (this.customCloneControlObject.source) {
                this.customCloneControlObject.source = '';
            }
            this.v$.customCloneControlObject.$reset();
        },
           async onCancelbtnCustomForCloning(prop:any){
            this.v$.$reset();
            if (prop === 'close') {
                this.addpopup=false;
                this.addControlpopup=false;
                this.clonePopup = false;
                this.dummyCustomCloneObj = {}
			}
            if(prop=='cancel'){
                this.frameworkControls=[];

               if(this.customCloneControlObject._id){
               this.customCloneControlObject={...this.dummyCustomCloneObj}
              }else{
                 Object.keys(this.customCloneControlObject).forEach((prop) => {
                Array.isArray(this.customCloneControlObject[prop])
                    ? (this.customCloneControlObject[prop] = [])
                    : (this.customCloneControlObject[prop] = "");
                });
                this.customCloneControlObject.controlNumber = this.dummyCustomCloneObj.controlNumber
              }
            }
            if(prop=='activecancel'){
                this.controlsEditData ={...this.dummyControlObj}
                this.setControlOwnerSelection(this.controlsEditData.controlOwner);
            }
             if(prop=='deactivateclose'){
                this.deActiveControlObject={justification:'',forceUpdate:''};
                this.deActivatingPopup = false;            
            }
            if(prop=='deactivecancel'){
                // this.controlsEditData ={...this.dummyControlObj}
                this.deActiveControlObject={justification:'',forceUpdate:''};
            }
            if(this.customControlObject._id){
                this.customCloneControlObject = {...this.dummyCustomCloneObj}
            }else{
                Object.keys(this.customControlObject).forEach((prop) => {
                Array.isArray(this.customControlObject[prop])
                    ? (this.customControlObject[prop] = [])
                    : (this.customControlObject[prop] = "");
                });
                this.customControlObject.controlNumber = this.dummyControlObj.controlNumber
            }
            
        },
         async saveCustomControlForCloning(obj:any){
            this.v$.$touch();
            if(!this.v$.customCloneControlObject.$invalid){
            if(obj.source!=undefined){
                obj.controlId = obj.source.value
            }
            delete obj.source;
            let typeId=10109;
            obj.createdAt = new Date().toISOString();
            obj.createdBy = this.userInfo._id;
            let newPayload:any=[];
            obj.frameworks = [
			   {
				"name":obj.controlOptionFrameWork,
				"controls":[obj.frameworkControls]
			   }
            ]

            obj.isInternalControl = true

            delete obj.controlOptionFrameWork
            delete obj.frameworkControls
            
        try{
            await this.$http.post(`${process.env.VUE_APP_CONTROLS_API}/type/${typeId}/${'project'}/${this.currentId}/control/clone`,obj).then(async (res: { data: any }) => {
                let result =  res.data;
                toast.info('Saved', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                })
                newPayload.push(res.data.insertedId);
                this.clonePopup = false;
                this.addpopup = false;
                await this.getInternalControls();
                await this.getAllInternalControls();
                await this.getAllActiveControls();
                await this.getActiveControlsForActivity();
            });
            this.customCloneControlObject={...this.dummyCustomCloneObj}
           
             await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,newPayload).then(async (res: { data: any }) => {
                            //console.log('result',res.data); 
                        })
        }catch(e){
            toast.error(`Error`, {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
            });
        }
    }  
        },
        async customClonePopup(){
            this.v$.$reset();
            this.clonePopup = true;
            this.addpopup=true; 
            this.customCloneControlObject = {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                source: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                controlGuidance: "",
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            }
            let controlId= await this.incrementAndAddCC();            
            this.customCloneControlObject.controlNumber = controlId;  
            this.dummyControlObj.controlNumber=controlId;
            // // let id = uuidv4();
            // // const truncatedUuid = id.replace(/-/g,'').substring(0, 8)
            // // this.customControlObject.controlNumber = truncatedUuid.toUpperCase();
            // // this.dummyCustomObj.controlNumber = truncatedUuid.toUpperCase();
            // let w= await this.incrementAndAddCC();            
            // this.customControlObject.controlNumber = w;  
            // this.dummyControlObj.controlNumber=w;          
        },
        getControlOwnerName(id:any){
            let owner:any = this.optionsUserArray.find((user:any)=>{return user.value == id})
            if(owner == undefined || owner == '' || owner == null){
                return 'N/A'
            }
            return owner.label
        },
        asyncFindControlOwner(event:any){
            const query = (event?.query || '').trim().toLowerCase();
            this.filteredControlOwnerOptions = this.optionsUserArray.filter((user:any) =>
                query === '' || (user.label || '').toLowerCase().includes(query)
            );
        },
        controlOwnerOption(id:any){
            if (id && typeof id === 'object' && id.label) {
                return id;
            }
            if (id === undefined || id === null || id === '') {
                return null;
            }
            return this.optionsUserArray.find((user:any) => String(user.value) === String(id)) || null;
        },
        setControlOwnerSelection(id:any){
            const owner = this.controlOwnerOption(id);
            this.controlOwnerSelection = owner;
            this.filteredControlOwnerOptions = owner ? [owner] : [...this.optionsUserArray];
        },
        onControlOwnerPicked(event:any, target:any){
            const selected = event?.value;
            if (!selected || typeof selected !== 'object') {
                return;
            }
            this.controlOwnerSelection = selected;
            if (target) {
                target.controlOwner = selected.value;
            }
        },
        async onExistingControlOwnerSelect(event:any){
            if(!this.customControlObject || !this.customControlObject._id || !this.controlOwnerChanged){
                return;
            }
            const selected = event?.value || this.controlOwnerSelection;
            const ownerId = selected && typeof selected === 'object' ? selected.value : this.customControlObject.controlOwner;
            this.customControlObject.controlOwner = ownerId;
            const obj = {
                controlId: this.customControlObject._id,
                controlOwner: ownerId,
                updatedBy: this.userInfo._id,
                updatedAt: new Date()
            };
            try {
                await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/control/${this.currentId}/20011/edit`, obj);
                [this.activeControlsList, this.activeControlsListDisplay, this.activeControlsListDummy].forEach((list:any) => {
                    const row = list && list.find((item:any) => item && item._id == this.customControlObject._id);
                    if(row){
                        row.controlOwner = ownerId;
                    }
                });
                toast.info('Updated', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
                this.onCancelbtnCustom('close');
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        async bindOtherFields(){
            if(this.customCloneControlObject!=undefined && this.customCloneControlObject.source!=undefined && this.customCloneControlObject.source!='' && typeof this.customCloneControlObject.source=='object'){
                let getCurrentIc = this.allInternalControls.find((control:any)=>this.customCloneControlObject.source.value==control._id);
                this.customCloneControlObject.controlTitle = getCurrentIc.controlTitle;
                this.customCloneControlObject.controlFrequency = getCurrentIc.controlFrequency;
                this.customCloneControlObject.controlPriority = getCurrentIc.controlPriority;
                this.customCloneControlObject.controlClass = getCurrentIc.controlClass;
                this.customCloneControlObject.controlOwner = getCurrentIc.controlOwner;
                this.setControlOwnerSelection(getCurrentIc.controlOwner);
                this.customCloneControlObject.controlFamily = getCurrentIc.controlFamily;
                this.customCloneControlObject.controlGuidance = getCurrentIc.controlGuidance;
                this.customCloneControlObject.Description = getCurrentIc.Description;
                this.customCloneControlObject.controlMaintenanceTask = getCurrentIc.controlMaintenanceTask;
                this.customCloneControlObject.controlPolicies = getCurrentIc.controlPolicies;
                this.customCloneControlObject.controlType = getCurrentIc.controlType;
                if(getCurrentIc.frameworks!=undefined && getCurrentIc.frameworks.length>0) {
                this.customCloneControlObject.controlOptionFrameWork = getCurrentIc.frameworks[0].name;
                let frameworkControlsData = await this.getFrameworkControls(getCurrentIc.frameworks[0].name)
                this.customCloneControlObject.frameworkControls = getCurrentIc.frameworks[0].controls[0];
                this.dummyCustomCloneObj={...this.customCloneControlObject}
                }
            }
            else if(!this.customCloneControlObject.source) {                 
                this.customCloneControlObject={
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                source: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                controlGuidance: "",
                Description:'',
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
                }
                let controlId= await this.incrementAndAddCC();            
                this.customCloneControlObject.controlNumber = controlId; 
            }
        },
        async getAllInternalControls(){
            await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/internalcontrols/get`).then((res: any) => {
                let controls = res.data;
                this.allInternalControls = res.data;
                controls = res.data;
                for (var i = 0; i < controls.length; i++) {
                    this.optionsForInternalControls.push({ label:controls[i].controlTitle, value:controls[i]._id });
                }
            });
        },
        async getAllActiveControls(){
            const result = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls`);
            this.customControl = [];
            result.data.map((r:any)=>{
                if(r.classificationType==10603) {
                    this.customControl.push(r.controlNumber)
                }
            })
        },
        asyncFindInternalControls(query:any) {            
            query = query.query.trim();
            if (query == '') {
                    this.filteredICOptions = [];
            } else {                
                this.filteredICOptions = this.optionsForInternalControls.filter((item:any) => 
                    item.label?.toLowerCase().includes(query.toLowerCase())
                );
                // let isNewOption = !this.optionsForInternalControls.some((item:any) => 
                //     item?.toLowerCase() === query.toLowerCase()
                // );
                // if (isNewOption && query !== '') {
                //     this.filteredICOptions.push(query);
                // }
            }
        },
        toggleMenu() {
            this.isMenuVisible = !this.isMenuVisible;
        },
        handleClickOutside(event:any) {
          const menuContainer = this.$refs.menuContainer;
          if (menuContainer && !menuContainer.contains(event.target)) {
            this.isMenuVisible = false;
          }
        },
        colorStatusBg(value:any){
           if (value == 1) {
            return ["bg-veryLowColor border-solid border border-lightgreen"];
          }
          else if (value == 2) {
            return ["bg-highColor border-solid border border-error"];
          }
        },
        colorStatusText(value:any){
          if(value==1){
            return ["text-lightgreen font-semibold"];
          }
          else if(value==2){
            return ["text-error font-semibold"];
          }
        },
        getStatusLabel(value:any){
          if(value=='N/A'){
            return ''
          }
          else{
            let a = this.activeValues.find((val:any)=>val.id == value);            
            return a!=undefined?a.value:''
          }
        },
        getProjectOwner(data:any){
            let matchedProjectOwner = this.optionsUserArray.find((proj:any)=>proj.value==data);
            if(matchedProjectOwner!=undefined){
                return matchedProjectOwner.label
            }
            else{
                return 'N/A'
            }  
        },
        getProjectLocation(data:any){
            let matchedProjectOwner = this.entitesDataArray.find((proj:any)=>proj.value==data);
            if(matchedProjectOwner!=undefined){
                return matchedProjectOwner.label
            }
            else{
                return 'N/A'
            }
            
            
        },
        colorPropBg(format: any, scaleScore: any) {
            if (format == 'circle') {
                if (scaleScore == 5) {
                    return ['bg-darkred'];
                } else if (scaleScore == 4) {
                    return ['bg-error'];
                } else if (scaleScore == 3) {
                    return ['bg-yellow'];
                } else if (scaleScore == 2) {
                    return ['bg-green'];
                } else if (scaleScore == 1) {
                    return ['bg-lightgreen'];
                }
            } else if (format == 'border') {
                if (scaleScore == 5) {
                    return ['border-darkred border-4'];
                } else if (scaleScore == 4) {
                    return ['border-error border-4'];
                } else if (scaleScore == 3) {
                    return ['border-yellow border-4'];
                } else if (scaleScore == 2) {
                    return ['border-green border-4'];
                } else if (scaleScore == 1) {
                    return ['border-lightgreen border-4'];
                }
            }
        },
        actionButtonAtControl(row: any) {
            if (this.selectedTabIndex == 1) {
                return this.controlDeactiveOptions.map((option:any) => ({
                    label: option.value === 'kpi' ? 'KPIs' : option.value,
                    icon: this.getIconForOption(option.value),
                    command: () => this.optionClickedOnAction(option.value, row),
                }));
            } else if (this.selectedTabIndex == 3) {
                return this.controlActiveOptions.map((option:any) => ({
                    label: option.value,
                    icon: this.getIconForOption(option.value),
                    command: () => this.optionClickedOnAction(option.value, row),
                }));
            }
            return [];
        },
        getIconForOption(value: string): string {
            switch (value) {
                case 'Edit':
                    return 'pi pi-pencil';
                case 'Deactivate':
                    return 'pi pi-ban';
                case 'Activate':
                    return 'pi pi-check';
                case 'kpi':
                    return 'pi pi-link'
                default:
                    return '';
            }
        },
        actionButtonToggle(event:any, index:any) {
            let menu = this.$refs['menu' + index];
            if (Array.isArray(menu)) menu = menu[0];
            if (menu && typeof menu.toggle === 'function') {
                menu.toggle(event);
            }
        },
        isObjectEmpty(obj:any) {            
            if(obj.justification==''&& obj.forceUpdate==''){
                if(obj.forceUpdate==false){
                    return false;
                }
                return Object.values(obj).some(val => val !== null && val !== undefined && val !== '');
            }
            if(obj.justification=='' && obj.forceUpdate == false){                
                return true;
            }
            return true;
        },
        sortWorkLog() {
            this.newHistory = !this.newHistory;
            this.workLogObject[0]?.history?.sort().reverse();
        },
        getPersonName(person: any) {
            if (person == undefined) {
                return "";
            } else {
                return this.userInfo.name;
            }
        },
        extractInitials(name: any) {
        if(name!=undefined){
          const names = name.split(" ");
            return names
            .map((name: any) => name[0])
            .join("")
            .toUpperCase();
        }
        else{
            return '';
        }
        },
        formatTime(time: any) {
            let now = moment(time);
            return now.format("DD-MM-YYYY, HH:mm:ss");
        },

        getFrameworkControls(name:any){
            this.frameworkControls=[];
            let array=Object.values(this.frameJson)
            array.forEach((x:any)=>{
                x.forEach((y:any)=>{
                if(y.controlFrameWork == name){
                    this.frameworkControls.push({label:`${y.controlNumber}` + `--` + `${y.controlTitle }`,value:y._id});
                    this.allFrameworkControls.push(`${y.controlNumber}` + `--` + `${y.controlTitle }`);
                }
                })
            })
		},
        async editCustomControl(obj:any,action:any){
            // !this.v$.customControlObject.$invalid
            if(this.selectedTabIndex==1){
                this.v$.controlsEditData.$touch()
            }
            if(action=='edit'){
                if(!this.v$.controlsEditData.$invalid || this.customPopup == true){                    
                    if(this.selectedTabIndex==1){
                        obj.controlId = this.controlsData?._id;
                        obj.updatedBy = this.userInfo._id;
                        obj.updatedAt = new Date();
                        delete obj.previousPriority;
                        delete obj.previousFrequency;
                        // obj.projectId = this.currentId
                        if(obj.controlPriority!=this.dummyControlObj.controlPriority){
                            obj.previousPriority = this.dummyControlObj.controlPriority
                        }
                        if(obj.controlFrequency!=this.dummyControlObj.controlFrequency){
                            obj.previousFrequency = this.dummyControlObj.controlFrequency
                        }
                    }
               
                try {
                    let projectId = this.currentId;
                    let type=20011; 
                    let result:any=[];                   
				await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/control/${projectId}/${type}/edit`,obj).then((res:any ) => {
                    result.push(res.data);
                    toast.info('Saved', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    })
                    delete obj.previousPriority;
                    delete obj.previousFrequency;

                    if(this.selectedTabIndex == 1){
                        this.getActiveControlsForActivity();
                    }
                    if(this.selectedTabIndex == 3){
                        this.customPopup=false;
                        this.getAllDeactivateControls();
                    }
                    this.controlEditPopup = false;
                    delete obj.updatedBy;
                    delete obj.activityId;
                    delete obj.updatedAt;
                    delete obj.controlId;
                    this.dummyControlObj = {...obj}
                });
                await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,result).then(async (res: { data: any }) => {
                    //console.log('result',res.data);
                })
                } catch (e) {
                    toast.error('error', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                }
                
            }
            // else{
            //     toast.error('error', {
            //         timeout: 1000,
            //         closeOnClick: true,
            //         closeButton: 'button',
            //         icon: true
            //     });
            //     // this.controlEditPopup = false;
                
            // }

            }
            else if(action=='deActive') {
                let projectId = this.currentId;
            if(!this.v$.deActiveControlObject.$invalid){
                obj.controlId = this.controlsData?._id;
                obj.updatedBy = this.userInfo._id,
                obj.updatedAt = new Date()
                let type=20011
                try {
                const activateControl = false;
				await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/${projectId}/${type}/control/inactive`,obj).then((res:any ) => {
                    if(res.data?.success==false){
                        this.pendingDeactivateRequest = {
                            scopeId: projectId,
                            inactiveType: type,
                            payload: { ...obj },
                        };
                        this.openInProgressTasksDialog(res.data?.tasks || res.data?.result || res.data);
                        if (this.showMessageDialog) {
                            this.customPopup = true;
                        }
                    } 
                    else{
                    toast.info('Saved', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    })
                    this.deActivatingPopup = false;
                    delete obj.controlId;
                    obj.justification='';
                    delete obj.updatedBy;
                    delete obj.updatedAt;
                    this.dummyDeActivateControlObject = {...obj};
                    this.getActiveControlsForActivity();
                    }
                });
                } catch (e:any) {
                    if (e.response?.status === 400) {
                        this.pendingDeactivateRequest = {
                            scopeId: projectId,
                            inactiveType: type,
                            payload: { ...obj },
                        };
                        this.openInProgressTasksDialog(e.response.data?.tasks || e.response.data?.result || e.response.data);
                    } else {
                        toast.error('error', {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
                }
            }else{
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });

            }
                
            }
            
        },
        async optionClickedOnAction(actionOption:any,rowData:any){
            if(actionOption=='Edit'){
                this.v$.controlsEditData.$reset();
                this.controlEditPopup = true;
                this.controlsData = rowData;
                if(Object.keys(this.controlsEditData).includes('controlNumber')){
                    delete this.controlsEditData.controlNumber
                }
                this.controlsEditData.controlPriority = this.controlsData?.controlPriority|| 'N/A';
                this.controlsEditData.controlFrequency = this.controlsData.controlFrequency
                if(this.controlsData && (this.controlsData.controlPriority == 'N/A'||this.controlsData.controlPriority == '')){
                    this.controlsEditData.controlPriority ='' 
                    rowData.controlPriority = ''  
                }
                if(this.controlsData && (this.controlsData.controlFrequency == 'N/A'||this.controlsData.controlFrequency == '')){
                    this.controlsEditData.controlFrequency ='' 
                    rowData.controlFrequency = ''   
                }            
                // delete this.controlEditData.controlNumber
                const priority = rowData.controlPriority;
                const frequency = rowData.controlFrequency;
                const controlOwner = this.controlsData?.controlOwner || '';
                this.controlsEditData.controlOwner = controlOwner;
                this.setControlOwnerSelection(controlOwner);
                this.dummyControlObj = {controlPriority:priority,controlFrequency:frequency,controlOwner:controlOwner}
            }
            else if(actionOption == 'Deactivate'){
                this.v$.deActiveControlObject.$reset();
                this.deActivatingPopup = true;
                this.controlsData = rowData;
            }
            else if(actionOption == 'Activate') {
                
            }
            else if(actionOption == 'kpi'){
                this.openControlKpi(rowData);
            }
        },
        
        async ActivateControl(id:any){
            let obj={
                controlId:id,
                updatedBy:this.userInfo._id,
                updatedAt:new Date()
            }            
            const activeControl = true;
            try{
                 await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/control?activate=${activeControl}`,obj).then((res:any ) => {
                    toast.info('Saved', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    })
                    // this.deActivatingPopup = false;
                    this.getAllDeactivateControls();
                });

            }
            catch (e) {
            toast.error('error', {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
            });
        }

        },
        calculateDropdownPosition(event:any, index: any, coloum: any) {
        
			 if (!this.dropdownDirection) {
                    this.dropdownDirection = {};
                }
            this.calculateDropdownDirection(index.toString());
			if(coloum == "actionButtonAtCompliance" || coloum == "actionButtonForControls" || coloum == "outerAction" || coloum == 'actionButtonForKPIs'){
				// console.log("this.showBlockindex",this.showBlockindex)
				if (this.showBlockindex === index) {
					this.showBlock = !this.showBlock;
					// console.log("this.showBlock",this.showBlock)
				} else {
					// console.log("showBlockindex", this.showBlockindex)
					this.showBlock = true;
					this.showBlockindex = index;
				}
			}
			this.showDropdown = false;
		},
		calculateDropdownDirection(index: string) {
            const actionButton = document.querySelector(`[data-row-index="${index}"]`);
            if (!actionButton) return;

            const buttonRect = actionButton.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            const estimatedDropdownHeight = 80; 
          
            const taskbarBuffer = 50;
            const visibilityBuffer = 20;
            const spaceBelow = windowHeight - buttonRect.bottom - taskbarBuffer;
            this.dropdownDirection[index] = spaceBelow < (estimatedDropdownHeight + visibilityBuffer) ? 'up' : 'down';
        },
        showControlDetailsPopup(data:any){
            this.customPopup = true;
            
            let framework:any 
            let frameworkControls:any
            if(data.frameworks && data.frameworks != undefined){
                if(data.frameworks.length>0 && data.frameworks!='N/A'){
                data.frameworks.map((frameworkObj:any) => {
                    framework = frameworkObj
                });
                this.getFrameworkControls(framework.name)
                framework.controls.map((frameworkcontrol:any)=>{
                    frameworkControls = this.frameworkControls.find((control:any)=>control.value==frameworkcontrol)
                })
                }
                else{
                    framework = '';
                }
                data.controlOptionFrameWork = framework!=undefined && framework.name != undefined ? framework.name : ''
                data.frameworkControls = frameworkControls != undefined || frameworkControls != null ? frameworkControls.label :''
            }
            if(!data.hasOwnProperty('controlFrequency')){
                 let controlFreq = this.allControlsList.find((control:any)=>control._id.toString()==data._id.toString());
                data.controlFrequency = controlFreq!=undefined?controlFreq.controlFrequency:'N/A'
            }
            if(!data.hasOwnProperty('controlPriority')){
                 let controlPriority = this.allControlsList.find((control:any)=>control._id.toString()==data._id.toString());
                data.controlPriority = controlPriority!=undefined?controlPriority.controlPriority:'N/A'
            }
            if(data.hasOwnProperty('controlDescription')) {
                data.Description = data.controlDescription;
            }
            this.customControlObject = {...data};
            this.dummyCustomObj = {...data}
            this.existingControlOwner = this.customControlObject.controlOwner != null ? this.customControlObject.controlOwner : '';
            this.setControlOwnerSelection(this.customControlObject.controlOwner);
            this.getFrameworkControls(data.controlOptionFrameWork)
        },
        cancelActiveControls(){
            this.checkedActiveControls = [...this.defaultCheckedActiveControls];
            if(this.checkedActiveControls.length == this.activeControlsList.length){
                this.selectAllOptionActiveControls = true;
            }else{
                this.selectAllOptionActiveControls = false;
            }
        },
        async  asyncFrameworkControl(query:any){
        // frameworkControls"
            query = query.query.trim();
            if (query == '') {
                    this.frameworkControls = [];
            } else {
                this.frameworkControls = this.allFrameworkControls.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
            }
        },
        asyncFindControlFamily(query:any) {
            query = query.query.trim();
            if (query == '') {
                    this.filteredControlFamilyOptions = [];
            } else {
                this.filteredControlFamilyOptions = this.ControlFamilyArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                let isNewOption = !this.ControlFamilyArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                if (isNewOption && query !== '') {
                    this.filteredControlFamilyOptions.push(query);
                }
            }
        },
        asyncFindControlClass(query:any) {      
            query = query.query.trim();            
            if (query == '') {
                    this.filteredControlClassOptions = [];
            } else {
                this.filteredControlClassOptions = this.controlClassArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                
                let isNewOption = !this.controlClassArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                if (isNewOption && query !== '') {
                    this.filteredControlClassOptions.push(query);
                }
            }
        },
        asyncFindControlType(query:any) {            
            query = query.query.trim();
            if (query == '') {
                    this.filteredControlTypeOptions = [];
            } else {
                this.filteredControlTypeOptions = this.ControlTypeArray.filter((item:any) => 
                    item?.toLowerCase().includes(query.toLowerCase())
                );
                let isNewOption = !this.ControlTypeArray.some((item:any) => 
                    item?.toLowerCase() === query.toLowerCase()
                );
                if (isNewOption && query !== '') {
                    this.filteredControlTypeOptions.push(query);
                }
            }
        },
        async customPopupPopup(){
            this.v$.$reset();
            this.customPopup = true;
            this.controlOwnerSelection = null;
            this.addpopup=true;
            this.customControlObject = {
                controlFrequency:"",
                controlNumber: "",
                controlPriority: "",
                controlTitle: "",
                controlClass: "",
                controlOwner: "",
                controlFamily: "",
                controlGuidance: "",
                controlAuditMethodology: "",
                controlAuditSuccessCriteria: "",
                controlMaintenanceTask: "",
                controlPolicies: "",
                controlType: "",
                controlOptionFrameWork: '',
                frameworkControls: '',
            }
            // let id = uuidv4();
            // const truncatedUuid = id.replace(/-/g,'').substring(0, 8)
            // this.customControlObject.controlNumber = truncatedUuid.toUpperCase();
            // this.dummyCustomObj.controlNumber = truncatedUuid.toUpperCase();
            let w= await this.incrementAndAddCC();            
            this.customControlObject.controlNumber = w;  
            this.dummyControlObj.controlNumber=w;          
        },
        async incrementAndAddCC() {
            const maxCCNumber = this.customControl.reduce((max: number, item: any) => {
                if (typeof item === 'string' && item.startsWith('CC-')) {
                const num = parseInt(item.split('-')[1]);
                if (!isNaN(num)) {
                    return Math.max(max, num);
                }
                }
                return max;
            }, 0);        
            const nextNumber = maxCCNumber + 1;
            const newCC = `CC-${nextNumber}`;
            return newCC;
        },

        onCancelbtnCustom(prop:any){
            this.v$.$reset();
            if (prop === 'close') {
                this.addpopup=false;
                this.addControlpopup=false;
                this.controlEditPopup = false;
                this.customPopup = false;
                this.clonePopup = false;
                this.dummyCustomObj = {}
                this.controlsEditData={...this.dummyControlObj};
                this.frameworkControls=[];
                 this.customCloneControlObject= {
                    controlFrequency:"",
                    controlNumber: "",
                    controlPriority: "",
                    controlTitle: "",
                    controlClass: "",
                    controlOwner: "",
                    controlFamily: "",
                    controlGuidance: "",
                    Description:'',
                    controlAuditMethodology: "",
                    controlAuditSuccessCriteria: "",
                    controlMaintenanceTask: "",
                    controlPolicies: "",
                    controlType: "",
                    controlOptionFrameWork: '',
                    frameworkControls: '',
                }
			}
            if(prop=='cancel'){
                this.frameworkControls=[];
                
            }
            if(prop=='activecancel'){
                this.controlsEditData ={...this.dummyControlObj}
                this.setControlOwnerSelection(this.controlsEditData.controlOwner);
            }
             if(prop=='deactivateclose'){
                this.deActiveControlObject={justification:'',forceUpdate:''};
                this.deActivatingPopup = false;            
            }
            if(prop=='deactivecancel'){
                // this.controlsEditData ={...this.dummyControlObj}
                this.deActiveControlObject={justification:'',forceUpdate:''};
            }
            if(this.customControlObject._id){
                this.customControlObject = {...this.dummyCustomObj}
            }else{
                Object.keys(this.customControlObject).forEach((prop) => {
                Array.isArray(this.customControlObject[prop])
                    ? (this.customControlObject[prop] = [])
                    : (this.customControlObject[prop] = "");
                });
                this.customControlObject.controlNumber = this.dummyControlObj.controlNumber
            }
            
        },
        onCancelAllControls(){
            this.customControlObject = [];
            this.selectAllOptionAllControls = false;
        },
        colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bg-veryLowColor border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bg-lowColor border-solid border border-green"];
            } else if (value == 3) {
                return ["bg-moderateColor border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bg-highColor border-solid border border-error"];
            } else if (value == 5) {
                return ["bg-veryHighColor border-solid border border-darkred"];
            }
        },
        getProirityLabel(val:any){
            if (val === 'N/A') { 
                return 'N/A'; 
            } else {
                let a = this.dbPriority.find((obj: any) => obj.value == val);
                return (val && typeof val === 'number') ? a.key : 'N/A';
            }
        },
        filtersOpen(){
             this.showFilters = !this.showFilters;
                if (this.showFilters == true) {
                    this.allControlsListDummy = this.allControlsListDisplay;
                } else {
                    this.allControlsListDisplay = this.allControlsListDummy;
                    //for (const key in this.allFilters) {
                        this.allFilters = {};
                    //}
                }
        },
        getHeaderProperties1(prop:any,columnName:any){
            if(prop=='name'){
                let a = this.tableProps1.headerNames.find((obj:any)=>{return obj.key == columnName});
                if(a!= undefined){
                    return a.value
                }else{
                    return columnName
                }

            }else if(prop=='width'){
                let a = this.tableProps1.headerWidth.find((obj:any)=>{return obj.key == columnName});
                if(a!= undefined){
                    return a.value
                }else{
                    return ''
                }
            }
            else if(prop=='widthInner'){
                let a = this.tableProps1.innerHeaderWidth.find((obj:any)=>{return obj.key == columnName});
                if(a!= undefined){
                    return a.value
                }else{
                    return ''
                }
            }
        },

        getHeaderProperties0(prop:any,columnName:any){
            if(prop=='name'){
                let a = this.tableProps0.headerNames.find((obj:any)=>{return obj.key == columnName}); 
                if(this.selectedTabIndex==3){
                   if(a?.key=='createdAt'){
                    a.value='deActivated on'
                   } 
                }
                if(this.selectedTabIndex==1){  
                    if(a?.key=='createdAt'){
                        a.value='Activated On'
                    }           
                }
                if(a!= undefined){
                    return a.value
                }else if(a==undefined && columnName == 'actionButtonForControls'){
                    return '';
                }
                else{
                    return columnName
                }

            }else if(prop=='width'){
                let a = this.tableProps0.headerWidth.find((obj:any)=>{return obj.key == columnName});                
                if(a!= undefined){
                    return a.value
                }
                else if(a==undefined && columnName == 'actionButtonForControls'){
                    return '';
                }
                else{
                    return ''
                }
            }else if(prop=='widthInner'){
                let a = this.tableProps0.innerHeaderWidth.find((obj:any)=>{return obj.key == columnName});
                if(a!= undefined){
                    return a.value
                }else{
                    return ''
                }
            }
        },
        getHeaderProperties2(prop:any,columnName:any){
            if(prop=='name'){
                let a = this.tableProps0.headerNames.find((obj:any)=>{return obj.key == columnName}); 
                if(this.selectedTabIndex==3){
                   if(a?.key=='createdAt'){
                    a.value='deActivated on'
                   } 
                }
                if(a!= undefined){
                    return a.value
                }else if(a==undefined){
                    return '';
                }
                else{
                    return columnName
                }

            }else if(prop=='width'){
                let a = this.tableProps0.headerWidth.find((obj:any)=>{return obj.key == columnName});                
                if(a!= undefined){
                    return a.value
                }
                else if(a==undefined && columnName == 'actionButtonForControls'){
                    return '';
                }
                else{
                    return ''
                }
            }else if(prop=='widthInner'){
                let a = this.tableProps0.innerHeaderWidth.find((obj:any)=>{return obj.key == columnName});
                if(a!= undefined){
                    return a.value
                }else{
                    return ''
                }
            }
        },
        doFalse() {
            emitter.emit('deActiviteToolTip')
        },
        getHeaderAlignment(column:any){
            // {key:'clientUniqueId',value:'CCID'},{key:'controlTitle',value:'Title'},{key:'createdAt',value:'Activated At'},{key:'controlFrequency',value:'Frequency'},{key:'classificationType',value:'Type'},{key:'controlPriority',value:'Priority'}
            if(column == 'clientUniqueId'){
                return 'w-24'
            } else if(column == 'controlTitle'){
                return 'w-24'
            } else if(column == 'createdAt'){
                return 'w-28'
            } else if(column == 'controlFrequency'){
                return 'w-28'
            } else if(column == 'classificationType'){
                return 'w-28'
            } else if(column == 'controlPriority'){
                return 'w-28'
            } else{
                return ''
            }
            

        },
        paginationUpdations(currentPage: any, pageSize: any) {
            this.currentPage = currentPage;
            this.pageSize = pageSize;
        },
        getResizeColumnNames() {
            if (this.selectedTabIndex === 2) {
                return this.allControlHeaders || [];
            }
            return this.filteredHeaders || this.activeControlHeaders || [];
        },
        openControlKpi(rowData: any) {
            if (this.modalMode) {
                this.$emit('open-nested', {
                    view: 'manageKPI',
                    title: rowData.controlTitle || 'Control',
                    params: { controlId: rowData._id, type: 10103 },
                });
                return;
            }
            this.$router.push({ name: 'manageKPI', params: { id: rowData._id, type: 10103 } });
        },
        emitMappingHeader() {
            if (!this.modalMode) {
                return;
            }
            this.$emit('header-info', { title: this.presentProjectObj?.projectName || 'Project' });
        },
        sort: function (s: any) {
            this.className = s;
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = s;
            this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
        },
        selectAllAllControls(e: any) {
            this.checkedAllControls = [];
            const checked = e.target.checked;
            if (checked) {
                for (let obj of this.allControlsList) {
                    this.checkedAllControls.push(obj._id);
                }
            } else {
                this.checkedAllControls = [];
            }
        },
        selectAllActiveControls(e:any){
            this.checkedActiveControls = [];
            const checked = e.target.checked;
            if (checked) {
                for (let obj of this.activeControlsList) {
                    this.checkedActiveControls.push(obj._id);
                }
            } else {
                this.checkedActiveControls = [];
            }
        },
        async getControlHistory() {
            const id = this.currentId
            let type:any=20011;
            await this.$http
            .get(
                // /api/org/project/:projectId/controls/history
            `${process.env.VUE_APP_MONITOR_API}/api/org/${type}/${id}/controls/history`
            )
            .then((result: any) => {                
            const mainObject = result.data;
            this.workLogObject = mainObject;
            });            
            this.workLogObject[0]?.history?.sort().reverse();
        },
        changedAllControlInput(){
            if(this.checkedAllControls.length == this.allControlsList.length){
                this.selectAllOptionAllControls = true;
            }else{
                 this.selectAllOptionAllControls = false;
            }
        },
        changedActiveControlInput(){
            if(this.checkedActiveControls.length == this.activeControlsList.length){
                this.selectAllOptionActiveControls = true;
            }else{
                 this.selectAllOptionActiveControls = false;
            }
        },
        toolTip(column: any, e: any, index: any, row: any, status: any) {
            this.toolTipText = row[column];
            this.tipColumn = column;
            this.tipIndex = index;            

           switch (status) {
				case 'text':
					this.handleTextTooltip(e,column);
					break;
				case 'label':					
                    let ValueKeys:any = ['criticality']
                      if(ValueKeys.includes(column)){
                         const container = e.currentTarget.closest('.table-ellipsisForValue');
                          if (container && this.isTextOverflowed(container)) {
                             let obj:any = {
                                tipText : this.tipText
                            }														
                            emitter.emit('activiteToolTip',obj)
                          }
                     }
                     break;
				case 'circleButton':
					if(this.tipText == 1){
                           let obj:any = {
                                tipText : 'Active'  
                            }
                             emitter.emit('activiteToolTip',obj)
                    }else if(this.tipText == 2){
                           let obj:any = {
                                tipText : 'Inactive'
                            }
                             emitter.emit('activiteToolTip',obj)
                    }
					break;
					case 'circle':
                    let findVal = this.dbSeverity.find((obj:any)=>{return obj.value == row['severity']})
                    if(findVal != undefined){
                        this.tipText = findVal.key
                    }else{
                        this.tipText = row[column]
                    }

                    let obj:any = {
                        tipText : this.tipText
                    }
                    emitter.emit('activiteToolTip',obj)
                    break
			}
        },
        handleTextTooltip(e: any) {
            const container = e.currentTarget.closest('.table-ellipsis');
            if (container && this.isTextOverflowed(container)) {
                let obj:any = {
                    tipText : this.toolTipText
                }

                emitter.emit('activiteToolTip',obj)
            }
        },
        isTextOverflowed(element: any) {
            return element.scrollHeight > element.clientHeight;
        },
        async toggleTabs(tabId: any) {
            this.dataLoading = true
            this.selectedTabIndex = tabId.id;
            //sessionStorage.setItem('selectedTab', tabId.id);
            this.selectedTabObj = tabId;
             //for (const key in this.allFilters) {
                this.allFilters = {};
            //}
            if(tabId.id == 0){
                await this.getAllProjects()
                await this.getallUsers();
                //await this.getAllEntities();

            }else if (tabId.id == 1) {
                this.currentPage = 1
                this.filtersOpen();
                emitter.emit('visible', false);
                this.showFilters = false;
                await this.getActiveControlsForActivity();
                await this.getAllControls();
                await this.getAllInternalControls();
                await this.getInternalControls();
                await this.getAllActiveControls();
                // this.sortedDataActiveControls =this.activeControlsListDisplay            
            } else if (tabId.id == 2) {
                this.currentPage = 1
                this.filtersOpen();
                emitter.emit('visible', false);
                this.showFilters = false;
                await this.getAllInternalControlsForActivity();
            } else if(tabId.id == 3){
                this.currentPage = 1
                this.showFilters = false;
                await this.getAllDeactivateControls();
            }
            else if(tabId.id==4){
                await this.getControlHistory();
            }

            this.columnWidths = {};
            this.dataLoading = false
            this.$nextTick(() => {
                if (typeof this.snapshotColumnWidths === 'function') {
                    this.snapshotColumnWidths();
                }
            });
        },
         async getAllEntities() {
			this.entitesDataArray = [];
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
					res.data.map((obj: any) => {
                        let a = { value: obj._id, label: obj.entityDisplayName };
						this.entitesDataArray.push(a);
					});
			});
		},
        async getallUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.usersList = res.data;
                this.orgUsersList = res.data;
                for (var i = 0; i < this.orgUsersList.length; i++) {
                    this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
                }
            });
        },
        // async getAllTenants() {
        //     await this.$http.get(`${process.env.VUE_APP_AUTH_API_URL}/tenants/getAll`).then((res: any) => {
        //         res.data.map((org: any) => {
        //             const obj = { id: org._id, name: org.organizationName };
        //             this.tenants.push(obj);
        //             const object = { value: org._id, label: org.organizationName };
        //             this.tenantsSelect.push(object);
        //         });
        //     });
        // },
        getControlTypeValue(a:any){
            let val = this.controlTypeValues.find((item:any)=>{ return item.id == a });
            if(val != undefined){
                return val.value
            }else{
                return 'N/A'
            }
        },

        getFrequencyValue(a:any){
            let val = this.dbFrequency.find((item:any)=>{ return item.value == a });
            if(val != undefined){
                return val.key
            }else{
                return 'N/A'
            }
        },

        async getAllInternalControlsForActivity(){
            this.allControlsListDisplay = [];
            this.allControlsListDummy = [];
            //this.ControlFamilyArray = [];
            this.controlTypeArray=[];
            this.controlClassArray=[];

            try{
                await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/project/${this.currentId}/allcontrols/get`).then((result: { data: any }) => {
                    this.allControlsList = [...result.data];

                    result.data.map((obj:any)=>{
                        let a = {
                            "_id":obj._id,
                            "controlNumber": obj.controlNumber == '' ? 'N/A': obj.controlNumber,
                            'controlTitle': obj.controlTitle == '' ? 'N/A': obj.controlTitle,
                            'controlFamily': (obj.controlFamily == '' || obj.controlFamily==undefined) ? 'N/A': obj.controlFamily,
                            'controlClass': (obj.controlClass == ''  || obj.controlClass==undefined)? 'N/A': obj.controlClass,
                            'classificationType': obj.classificationType,
                            'controlType':obj.controlType==''?'N/A':obj.controlType,
                            'controlPriority': (isNaN(obj.controlPriority) || obj.controlPriority === '') ? 'N/A' : obj.controlPriority,
                            'controlGuidance':(obj.controlGuidance == '' || obj.controlGuidance==undefined)? 'N/A': obj.controlGuidance,
                            'controlMaintenanceTask':(obj.controlMaintenanceTask=='' || obj.controlMaintenanceTask==undefined) ?'N/A':obj.controlMaintenanceTask,
                            'controlPolicies':(obj.controlPolicies=='' || obj.controlPolicies==undefined)?'N/A':obj.controlPolicies,
                            'Description':(obj.Description=='' || obj.Description == undefined)?'N/A':obj.Description,
                            'frameworks':obj.frameworks==''?'N/A':obj.frameworks,
                        }
                        //if (Object.keys(obj).includes('controlFamily') && (obj.controlFamily != "" || obj.controlFamily != null || obj.controlFamily != undefined) && !this.ControlFamilyArray.includes(obj.controlFamily)) {
                            //this.ControlFamilyArray.push(obj.controlFamily);
                        //}
                        //if (Object.keys(obj).includes('controlType') && (obj.controlType != "" || obj.controlType != null || obj.controlType != undefined) && !this.controlTypeArray.includes(obj.controlType)) {
                            //this.ControlTypeArray.push(obj.controlType);
                        //}
                        //if (Object.keys(obj).includes('controlClass') && (obj.controlClass != "" || obj.controlClass != null || obj.controlClass != undefined) && !this.controlClassArray.includes(obj.controlClass)) {                            
                            //this.controlClassArray.push(obj.controlClass);
                        //}                                
                        this.allControlsListDisplay.push({...a});
                        this.allControlsListDummy.push({...a})
                    })


                });
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }

        },
        
        async getActiveControlsForActivity(){
            this.activeControlsList = []
            this.activeControlsListDisplay = []
            this.activeControlsListDummy = [];
            this.defaultCheckedActiveControls = [];
            this.checkedActiveControls = []

            let dummy:any = []
            try{
                await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/project/${this.currentId}/controls/getall?active=true`).then((result: { data: any }) => {
                    dummy = result.data
                })
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }

            dummy.map((obj:any,index:any)=>{
                this.checkedActiveControls.push(obj._id)
                this.defaultCheckedActiveControls.push(obj._id);
                if(obj.updatedAt && obj.isActive==true){
                    obj.createdAt = this.getDateFormat(obj.updatedAt)
                }
                else{
                    obj.createdAt = this.getDateFormat(obj.createdAt);
                }
                if(obj && typeof obj.controlPriority === 'number'){
                    obj.controlPriority = obj.controlPriority
                } else {
                    obj.controlPriority = "N/A"
                }
                if(obj && (obj.controlFrequency === '' ||obj.controlFrequency === undefined|| obj.controlFrequency === "N/A")){
                    obj.controlFrequency = "N/A"
                } else {
                    obj.controlFrequency = obj.controlFrequency
                }
                //if (Object.keys(obj).includes('controlFamily') && (obj.controlFamily != "" || obj.controlFamily != null || obj.controlFamily != undefined) && !this.ControlFamilyArray.includes(obj.controlFamily)) {
                    //this.ControlFamilyArray.push(obj.controlFamily);
                //}
                //if (Object.keys(obj).includes('controlType') && (obj.controlType != "" || obj.controlType != null || obj.controlType != undefined) || !this.controlTypeArray.includes(obj.controlType)) {
                   // this.ControlTypeArray.push(obj.controlType);
                //}
                //if (Object.keys(obj).includes('controlClass') && (obj.controlClass != "" || obj.controlClass != null || obj.controlClass != undefined) && !this.controlClassArray.includes(obj.controlClass)) {                            
                    //this.controlClassArray.push(obj.controlClass);
                //} 
            })

            this.activeControlsList = [...dummy]
            this.activeControlsListDisplay = [...dummy];
            this.activeControlsListDummy = [...dummy];

            if(this.checkedActiveControls.length == this.activeControlsList.length && this.activeControlsList.length!=0){
                this.selectAllOptionActiveControls = true;
            }else{
                this.selectAllOptionActiveControls = false;
            }
            
        },
        async getAllDeactivateControls(){
            let dummy:any = []
              try{
                await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/project/${this.currentId}/controls/getall?active=false`).then((result: { data: any }) => {
                    dummy = result.data
                })
            } catch (e) {
                toast.error('error', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
            dummy.map((obj:any,index:any)=>{
                this.checkedActiveControls.push(obj._id)
                this.defaultCheckedActiveControls.push(obj._id);
                if(obj.updatedAt && obj.isActive==false){
                    obj.createdAt = this.getDateFormat(obj.updatedAt)
                }
                else{
                    obj.createdAt = this.getDateFormat(obj.createdAt);
                }
                if(obj && typeof obj.controlPriority === 'number'){
                    obj.controlPriority = obj.controlPriority
                } else {
                    obj.controlPriority = "N/A"
                }
                if(obj && (obj.controlFrequency === '' ||obj.controlFrequency === undefined|| obj.controlFrequency === "N/A")){
                    obj.controlFrequency = "N/A"
                } else {
                    obj.controlFrequency = obj.controlFrequency
                }
            })
            this.activeControlsList = [...dummy]
            this.activeControlsListDisplay = [...dummy];
            this.activeControlsListDummy = [...dummy];

        },
           async getInternalControls() {
			this.tabDataLoading = true
            this.totalOrgControls = [];
            try{
            // let resultofFramework = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API_URL}/api/tenant/org/controls/get`);
            let allIC = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls?frameWork=InternalControls`);
            let new1 = this.activeFrameworks;
            let new2 = allIC.data;
            if(new1!=undefined && new1.length>0 && new2!=undefined && new2.length>0){
                let activeFramework = new1.find((n:any)=>n.frameWorkName=='InternalControls' && n.isActive==true);
                if(activeFramework!=undefined){
                    new2.forEach((n1:any)=>{
                        if(n1.classificationType==10603){
                            this.customControl.push(n1.controlNumber)
                        }
                    })
                    
                }                
            }
            if(new2 && new2.length>0){                
                new2.map((control:any)=>{
                    if(control.controlType!='' && control.controlType!=null && control.controlType!=undefined && (this.ControlTypeArray && !this.ControlTypeArray.includes(control.controlType))){
                        this.ControlTypeArray.push(control.controlType)
                    }
                    if(control.controlFamily!='' && control.controlFamily!=null && control.controlFamily!=undefined && (this.ControlFamilyArray && !this.ControlFamilyArray.includes(control.controlFamily))) {
                        this.ControlFamilyArray.push(control.controlFamily);
                    }
                    if(control.controlClass!='' && control.controlClass!=null && control.controlClass!=undefined &&(this.controlClassArray && !this.controlClassArray.includes(control.controlClass))){
                        this.controlClassArray.push(control.controlClass)
                    }
                })
            }
            }catch (e) {
				toast.error(`Something went wrong`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
            this.tabDataLoading = false
		// 	await this.$http
		// 		.get(`${process.env.VUE_APP_CONTROLS_API_URL}/api/org/allControls?frameWork=InternalControls`)
		// 		.then((result: { data: any }) => {
		// 			this.isLoading = true;
		// 			this.showLoader = false;
		// 			result.data.forEach((item: any) => {
		// 				if (item.isInternalControl) {
		// 					this.controlsList.push(item);
		// 				}
		// 			});
        //   this.editObject = {...this.controlObject}
		// 		})
		// 		.catch((error: any) => {
		// 			this.isLoading = false;
		// 			(this.showLoader = false),
		// 				toast.error(`Save failed with ${error}`, {
		// 					timeout: 1000,
		// 					closeOnClick: true,
		// 					closeButton: 'button',
		// 					icon: true
		// 				});
		// 		});
			//this.makeTable();
		},
        getDateFormat(date: any) {
            if (date == "") {
                return "None";
            } else {
                let now = moment(date);
                return now.format("DD-MM-YYYY");
            }
        },

        async getAllControls(frameName: any) {
            this.tabDataLoading = true
            this.totalOrgControls = [];

			try {
				const result = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`);
                const getControls = await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/tenant/org/controls/get`);
				
				this.totalOrgControls = result.data;
                this.activeFrameworks = getControls.data;

				let arr: any = [];

                if((this.totalOrgControls != null || this.totalOrgControls != undefined) && this.totalOrgControls.length != 0){
                    this.totalOrgControls.forEach((item: any) => {
                        this.activeFrameworks.forEach((framework:any)=>{
                            if (item.controlFrameWork && item.controlNumber && Object.keys(item).includes('controlFrameWork') && item.controlFrameWork!='Active Controls'&&  Object.keys(item).includes('controlNumber') && !Object.keys(item).includes('isInternalControl')&& framework.frameWorkName.toLowerCase() === item.controlFrameWork.toLowerCase() && framework.isActive==true) {
                                arr.push(item);
                                this.frameJson = this.groupByFrameworks(arr);
                            }
                        });
                    });
                    
                    let displayFrameName = '';	
                    if(this.frameJson != undefined){
                        Object.keys(this.frameJson).forEach((key, index) => {
                            if (frameName === index) {
                                displayFrameName = key;
                            }
                            if(!this.frameWorksList.includes(key)){
                                this.frameWorksList.push(key);
                            }
                        });
                    }
                }
			} catch (e) {
				toast.error(`Something went wrong`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
            this.tabDataLoading = false
		},
        groupByFrameworks(arr: any[]) {
			return arr.reduce((group: any, product: any) => {
				const { controlFrameWork } = product;
				group[controlFrameWork] = group[controlFrameWork] ?? [];
				group[controlFrameWork].push(product);
				return group;
			}, {});
		},
        
        
        
        calculateTabsPerGroup() {
            const tabContainerWidth = this.$refs.tabContainer.clientWidth;

            let sumWidth = 0;
            let count = 0;
            const tabs = this.carouselHead;

            for (let i = 0; i < tabs.length; i++) {
                const tabWidth = this.getTabWidth(tabs[i]);

                if (sumWidth + tabWidth > tabContainerWidth) {
                    break;
                }

                sumWidth += tabWidth;
                count++;
            }
            this.tabsPerGroup = count;
            this.updateVisibleTabs();
        },
        calculateTabsForLargeScreen() {
            const tabContainerWidth = this.$refs.tabContainer.clientWidth;

            const tabs = this.carouselHead;
            let sumWidth = 0;
            let count = 0;

            for (let i = 0; i < tabs.length; i++) {
                const tabWidth = this.getTabWidth(tabs[i]);

                if (sumWidth + tabWidth > tabContainerWidth) {
                    break;
                }

                sumWidth += tabWidth;
                count++;
            }
            return count;
        },
        getTabWidth(tab: any) {
            // Simulate tab width calculation; replace with your actual logic
            const dummyDiv = document.createElement('div');
            dummyDiv.innerHTML = tab.displayName;
            dummyDiv.style.display = 'inline-block';
            dummyDiv.style.visibility = 'hidden';
            document.body.appendChild(dummyDiv);
            const width = dummyDiv.clientWidth;
            document.body.removeChild(dummyDiv);
            return width + 24; // Adjust padding or margin as needed
        },
        async updateVisibleTabs() {
            if (!this.isSmallScreen) {
                this.visibleTabs = [...this.carouselHead];
            } else {
                const startIdx = this.currentGroupIndex * this.tabsPerGroup;
                const endIdx = startIdx + this.tabsPerGroup;
                this.visibleTabs = this.carouselHead.slice(startIdx, endIdx);
                if (this.visibleTabs) {
                    let savedTabKey: any = sessionStorage.getItem('selectedTab');
                    savedTabKey = parseInt(savedTabKey)
                    if (savedTabKey) {
                        const savedTab = this.visibleTabs.find((tab: any) => tab.id == savedTabKey);
                        if (savedTab) {
                            await this.toggleTabs(savedTab);
                        }else{
                            this.selectedTabObj = { displayName: 'Process', name: 'Process', id: 0 },
                            this.selectedIndex = 0;
                        }
                    }
                    else{
                        this.selectedTabObj = { displayName: 'Process', name: 'Process', id: 0 },
                        this.selectedIndex = 0;
                        await this.toggleTabs(this.selectedTabObj);
                    }
                }
                this.totalGroups = Math.ceil(this.carouselHead.length / this.tabsPerGroup);
            }
        },
        
        
        


        mapTheSelectedControlsToActivity(){
            //console.log('SELECTED CONTROLS FOR MAPPING',this.checkedAllControls)
        },

        unMapActiveControlsToActivity(){
            const deselectedControls = this.defaultCheckedActiveControls.filter((id:any) => !this.checkedActiveControls.includes(id));
        },
        async active(presentObj:any){
                let obj:any={};
                if(presentObj.controlPriority!=this.dummyCustomObj.controlPriority){
                    obj.controlPriority = presentObj.controlPriority;
                    obj.previousPriority = this.dummyCustomObj.controlPriority
                }
                if(presentObj.controlFrequency!=this.dummyCustomObj.controlFrequency){
                    obj.controlFrequency = presentObj.controlFrequency;
                    obj.previousFrequency = this.dummyCustomObj.controlFrequency
                }
                obj.updatedBy = this.userInfo._id;
                obj.updatedAt = new Date();
                obj.controlId = presentObj._id;
                // const controlId = this.dummyCustomObj._id                
                // console.log('controlId',controlId,this.dummyCustomObj,this.customControlObject)
                await this.editCustomControl(obj,'edit');
                // this.customPopup=false;
        },
        async activeInfo(obj:any){
        },
        async saveControlsChangeForActivity(type:any){                        
                this.checkedAllControls.push(this.dummyCustomObj._id);
            
            let payload:any ={
                "mappedControls":[]
            }
           
            this.clickOnButton=true;
            if(type == 10301){
                
                if(this.customControlObject.controlFrequency!=this.dummyCustomObj.controlFrequency){
                    payload.controlFrequency = this.customControlObject.controlFrequency
                    payload.previousFrequency = this.dummyCustomObj.controlFrequency
                }
                 if(this.customControlObject.controlPriority!=this.dummyCustomObj.controlPriority){
                    payload.controlPriority = this.customControlObject.controlPriority
                    payload.previousPriority = this.dummyCustomObj.controlPriority
                }
                payload.mappedControls = this.checkedAllControls
                payload.createdBy = this.userInfo._id
                payload.createdAt = new Date()
            }else if(type == 10303){
                let deselectedControls:any = this.defaultCheckedActiveControls.filter((id:any) =>{
                    !this.checkedActiveControls.includes(id)
                } );
                payload.mappedControls = deselectedControls
            }
            sessionStorage.setItem('selectedTab',this.selectedTabIndex);
            try {
                let result:any;
				await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/org/api/project/${this.currentId}/${type}/controlsmapping`,payload).then(async (res: { data: any }) => {
                    result = res.data;
                    if(result==''){
                        toast.error('This control is not mapped to any framework', {
                        timeout: 5000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                        });
                        await this.getActiveControlsForActivity();
                    }else{
                        toast.info('Saved', {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                        })
                    }
                    this.checkedAllControls = [];
                    this.checkedActiveControls = [];
                    this.defaultCheckedActiveControls = [];
                });
                await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,result).then(async (res: { data: any }) => {
                    //console.log('result',res.data); 
                })
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}finally {
                this.customPopup=false
				this.clickOnButton = false;
			}

            let savedTabKey: any = sessionStorage.getItem('selectedTab');
        
            savedTabKey = parseInt(savedTabKey)
            if (savedTabKey) {
                const savedTab = this.carouselHead.find((tab: any) => tab.id == savedTabKey);
                
                if (savedTab) {
                    await this.toggleTabs(savedTab);
                }else{
                    this.selectedTabObj = { displayName: 'Process', name: 'Process', id: 0 },
                    this.selectedIndex = 0;
                }
            }
            else{
                this.selectedTabObj = { displayName: 'Process', name: 'Process', id: 0 },
                this.selectedIndex = 0;
                await this.toggleTabs(this.selectedTabObj);
            }
            this.selectAllOptionAllControls = false;
            sessionStorage.removeItem('selectedTab'); 
        },

        async saveCustomControl(obj:any){
            this.v$.$touch()

            if(!this.v$.customControlObject.$invalid){
            let a = {...this.customControlObject}

            a.frameworks = [
			   {
				"name":a.controlOptionFrameWork,
				"controls":[a.frameworkControls]
			   }
            ]

            a.isInternalControl = true

            delete a.controlOptionFrameWork
            delete a.frameworkControls

            let payload = [
                {
                    "controlFrameWork":"InternalControls",
                    "controlsList":[a]
                }
            ];
            this.clickOnButton=true;
            try{
                 if(payload[0].controlsList[0].hasOwnProperty('controlType') && payload[0].controlsList[0].controlType ==null){
                    payload[0].controlsList[0].controlType =''
                }
                await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/project/${this.currentId}/controlset/create`,payload).then(async (res: { data: any }) => {
                    let cameIds:any = []
                    cameIds.push(res.data.insertedIds[0]);

                    if(cameIds.length > 0){
                        let newPayload = [{
                            "projectId": this.currentId,
                            "controlIds":cameIds,
                            "createdBy":this.userInfo._id,
                            "createdAt":new Date()
                        }];
                        let result:any;                      
                        await this.$http.post(`${process.env.VUE_APP_MONITOR_API}/api/org/controls/${this.currentId}/manageProject`,newPayload).then(async (res: { data: any }) => {
                            result = res.data
                            toast.info('Saved', {
                                timeout: 1000,
                                closeOnClick: true,
                                closeButton: 'button',
                                icon: true
                            });
                            this.onCancelbtnCustom('close')
                            await this.getActiveControlsForActivity();
                            await this.getInternalControls();
                            await this.getAllInternalControlsForActivity();
                            await this.getAllActiveControls();
                        })
                         await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/active/controls/tasks/create`,[result]).then(async (res: { data: any }) => {
                            //console.log('result',res.data); 
                        })
                    }
				});
            }catch(e:any){
                if(e.response.status==403){
                    toast.error(`${e.response.data.error}`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                    });
                }
                else {
                    toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
                }
            }finally {
				this.clickOnButton = false;
			}}
        },
        
        async fetchActivitiesList() {
			try {
				this.showLoader = true;
				await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/processes/mappedcontrols/count`).then((res: { data: any }) => {
					this.departmentsList = res.data;
					if (this.departmentsList.length > 0) {
						this.presentActivityObj = this.departmentsList.find((activity: any) => {return activity._id == this.currentId});
                    }
				});
			} catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			this.showLoader = false;
		},
        async getAllProjects(){
			this.projectDataArray = [],
			this.dataLoading = true;
			await this.$http.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/projects/mappedcontrols/count`).then((res: any) => {
				this.originalProjectData = res.data;
                this.presentProjectObj = this.originalProjectData.find((project:any)=>project._id == this.currentId);
                this.emitMappingHeader();                

				res.data.map((originalProjectData:any)=>{

					let locationoptions=this.entitesDataArray.find((obj:any)=>{
						
						// console.log(' obj.value', obj.value)
						// console.log('originalProjectData.value',originalProjectData.owner)
						return obj.value==originalProjectData.entity})
						// console.log('locationoptions',locationoptions)
					let typeoptions=this.projectTypeOptions.find((data:any)=>{return data.value==originalProjectData.projectType})
						// console.log('typeoptions',typeoptions,this.optionsUserArray)
					let Priority=this.priorityData.find((data:any)=>{
						// console.log('data.id',data.id)
						// console.log('originalProjectData',originalProjectData)
						return data.id==originalProjectData.priority})
						// console.log('Priorityq121212',Priority.value)
						// console.log('originalProjectData.Prio/rity',originalProjectData.Priority,this.severitydata)
					let severityData=this.severitydata.find((data:any)=>{
						// console.log('data',data.id)
						// console.log('originalProjectData',originalProjectData.severity)
						return data.id==originalProjectData.severity})
					let ownerInfo = this.optionsUserArray.find((user:any)=>{return user.value==originalProjectData.owner});      
					// console.log('severityData',severityData) 	
					let tableData = { 
                        '_id':originalProjectData._id,
                        'Type':typeoptions != undefined ? typeoptions.value : 'N/A',
                        'Name' : originalProjectData.projectName!=undefined?originalProjectData.projectName:'N/A',
                        'Customer' : originalProjectData.customerName != undefined && originalProjectData.customerName!=''? originalProjectData.customerName : 'N/A',
                        'projectOwner' : ownerInfo!=undefined?ownerInfo.label:'N/A',
                        'entityDisplayName' : locationoptions!=undefined?locationoptions.label:'N/A',
                        'Time Period':originalProjectData.startDate!= undefined && originalProjectData.endDate!=undefined? `${originalProjectData.startDate} to ${originalProjectData.endDate}` : 'N/A',
                        'Priority' :Priority.value!=undefined?Priority.value:'N/A',
                        'severity' : severityData.id!=undefined?severityData.id:'N/A',
                        'status' : originalProjectData.isActive==true ? 1:2 ,
                        'No. of Controls':originalProjectData.controlCount?originalProjectData.controlCount:0	
					}
					this.tableRow.push(tableData)                                        
					this.dataLoading = false;
					this.projectName=[]
					this.originalProjectData.forEach((name: any)=>{
                    if(name.projectName != null){
                       
                       this.projectName.push(name.projectName)
                    }
					})
				})
			})

		},
    },
    async mounted() {
        this.visibleTabs = [...this.carouselHead];
        document.addEventListener('click', this.handleClickOutside);
    
	// Do not steal list-page ActivityData listeners while open as a details modal
	if (!this.modalMode) {
		emitter.off('ActivityData')
		emitter.on("ActivityData", (isData: any) => {
			this.activeInfo(isData);
		});
		emitter.off('activiteToolTip');
		emitter.off('deActiviteToolTip');
	}
		this.onActiviteToolTip = (data: any) => {
			this.toolTipActive = true;
			this.toolTipText = data.tipText
		};
		this.onDeActiviteToolTip = (data: any) => {
			this.toolTipActive = false;
			this.toolTipText = ''
		};
		emitter.on('activiteToolTip', this.onActiviteToolTip);
		emitter.on('deActiviteToolTip', this.onDeActiviteToolTip);

        emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isSidebarToggle = isToggle;
		});
        emitter.on('*', (type, booleanValue) => {
			if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
				this.showBlock == true ? (this.showBlock = false) : '';
			} else {
				if (this.showDropdown === true && type != 'deActiviteToolTip') {
					this.showBlock == true ? (this.showBlock = booleanValue) : '';
				} else if (this.showDropdown === false) {
					this.showBlock == true ? '' : (this.showBlock = booleanValue);
					this.showDropdown = true;
				}
            }
		});
		emitter.on('apps', (isToggle: any) => {
			this.showBlock = isToggle;
		});
    },
    async created() {
        this.dataLoading = true;
        this.tabDataLoading = true
        // await this.getInternalControls();
        await this.getAllEntities();
        // await this.getAllProjects();
        // await this.getAllTenants();
        // await this.getAllControls();
        this.tabDataLoading = false
        
        let savedTabKey: any = this.modalMode ? null : sessionStorage.getItem('selectedTab');
        
        savedTabKey = parseInt(savedTabKey)
		if (savedTabKey) {
		    const savedTab = this.carouselHead.find((tab: any) => tab.id == savedTabKey);
            
            if (savedTab) {
                await this.toggleTabs(savedTab);
            }else{
                this.selectedTabObj = { displayName: 'Process', name: 'Process', id: 0 },
                this.selectedIndex = 0;
            }
		}
		else{
			this.selectedTabObj = { displayName: 'Process', name: 'Process', id: 0 },
			this.selectedIndex = 0;
            await this.toggleTabs(this.selectedTabObj);
		}

        this.dataLoading = false;
        
         this.routesArray = [
            { name:"Project", routeName: "ProjectLevel" },
            { name: 'Controls', routeName: "" },
        ];
        this.emitMappingHeader();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        sessionStorage.removeItem('selectedTab');
		if (this.onActiviteToolTip) {
			emitter.off('activiteToolTip', this.onActiviteToolTip);
		}
		if (this.onDeActiviteToolTip) {
			emitter.off('deActiviteToolTip', this.onDeActiviteToolTip);
		}
    }
});
</script>